<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout align-start>
      <v-flex>
        <!-- Modal Escaner código de barra -->
        <v-dialog v-model="dialogCamara" max-width="400" persistent>
          <v-card>
            <v-toolbar dense flat color="primary" dark>
              <v-toolbar-title>Escanear Código</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="detenerEscaneo"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pa-2">
              <video ref="video" autoplay muted playsinline
                style="width: 100%; height: auto; object-fit: cover; border-radius: 8px;" />
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal escaner código de barra -->

        <!-- Modal persona -->
        <v-dialog v-model="verPersona" max-width="700px" persistent>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>Nuevo Cliente</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="guardarPersona" :loading="desabilitarPer" :disabled="desabilitarPer || !isValidPer">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn icon @click="closePersona">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="isValidPer">
                <v-row class="mt-2">
                  <v-col cols="6" sm="3">
                    <v-select dense v-model="idtipo_documento_pers" :items="tipo_documentos_cli" label="Tipo Documento"
                      :rules="[v => !!v || 'Tipo documento requerido']" @change="num_documento = ''" hide-details>
                    </v-select>
                  </v-col>
                  <v-col cols="10" sm="5">
                    <v-text-field dense v-model.trim="num_documento" label="Numero Documento"
                      :rules="[v => !!v || 'Numero documento requerido', v => (idtipo_documento_pers == 1 ? v.length == 8 || 'Numero DNI' : v.length == 11 || 'Numero RUC')]"
                      :maxlength="idtipo_documento_pers == 1 ? 8 : 11"
                      :disabled="idtipo_documento_pers == 1 ? false : idtipo_documento_pers == 6 ? false : true"
                      @keypress="common.isNum($event)" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="1">
                    <div class="text-center">
                      <v-btn x-small fab color="primary" class="hide-detailswhite--text" :loading="desabilitarBuscar"
                        :disabled="(idtipo_documento_pers == 1 && num_documento.length == 8 ? false : idtipo_documento_pers == 6 && num_documento.length == 11 ? false : true) || desabilitarBuscar"
                        @click="extraerDocumento()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="nombre"
                      :label="idtipo_documento_pers == 1 ? 'Apellidos y Nombres' : 'Nombre'"
                      :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 200) || 'Nombre debe tener entre 3 a 200 caracteres']"
                      maxlength="100" prepend-inner-icon="person" v-uppercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete dense @keyup="selectUbigeo()" :search-input.sync="buscar_ubigeo" v-model="idubigeo"
                      :items="ubigeos" label="Ubigeo" :rules="[v => !!v || 'Ubigeo requerido']"
                      prepend-inner-icon="pin_drop" clearable class="mr-1"></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="direccion" label="Direccion"
                      :rules="[v => v.length <= 200 || 'La dirección no debe tener mas de 200 caracteres']"
                      maxlength="200" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field dense v-model.trim="email" label="Email"
                      :rules="[v => v == '' ? !v : /.+@.+\..+/.test(v) || 'Ingrese un email valido', Rules.sinespacio]"
                      maxlength="60" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field dense v-model.trim="telefono" label="Telefono"
                      :rules="[v => v.length <= 30 || 'El Telefono no debe tener mas de 30 caracteres', Rules.unespacio]"
                      maxlength="30" prepend-inner-icon="phone" v-uppercase hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal persona -->

        <!-- Producto -->
        <v-dialog v-model="verProductos" max-width="1200px">
          <v-card>
            <v-toolbar dark dense class="primary mb-1" flat>
              <v-toolbar-title>Productos</v-toolbar-title>
              <v-row>
                <v-spacer />
                <v-col cols="5" md="3" sm="3">
                  <v-select dense solo-inverted v-model="vts.nombre" :items="vts.ventas" label="Precios" hide-details>
                  </v-select>
                </v-col>
                <v-spacer />
                <v-col cols="7" md="8" sm="8">
                  <v-text-field dense solo-inverted v-model.trim="brDescripcion" label="Buscar Productos"
                    prepend-inner-icon="search" clearable hide-details @keyup="listarProductoBuscar">
                  </v-text-field>
                </v-col>
                <v-spacer />
              </v-row>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="mostrarEstablecimientos()" v-on="on">
                    <v-icon>category</v-icon>
                  </v-btn>
                </template>
                <span>Stock Establecimientos</span>
              </v-tooltip>

              <v-btn icon @click="ocultarProductos()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <!-- Mostrar imagen de producto -->
              <v-dialog v-model="selectedZoom" max-width="350px">
                <v-avatar tile size="350">
                  <img :src="'data:image/png;base64,' + imagen_zoom" />
                </v-avatar>
              </v-dialog>
              <!-- Fin Mostrar imagen de producto -->
              <v-form v-model="isValidP">
                <v-data-table :headers="cabeceraBusquedaProductos" :items="productos" :items-per-page="15"
                  item-key="iddetalle_compra" show-expand class="elevation-3" @dblclick:row="dblClickRepuesto" dense>

                  <template v-slot:item.seleccionar="{ item }">
                    <v-icon @click="agregarDetalle(item)" color="primary" :disabled="!isValidP">control_point</v-icon>
                  </template>

                  <template v-slot:item.imagen="{ item }">
                    <template>
                      <v-avatar tile size="27">
                        <img :src="'data:image/png;base64,' + item.imagen" @click="verImagen(item)" />
                      </v-avatar>
                    </template>
                  </template>

                  <template v-slot:item.codigos="{ item }">
                    <strong class="primary--text">{{ item.codigo_producto }} </strong> <br /> {{ item.codigo_producto2
                    }}
                  </template>

                  <template v-slot:item.marca="{ item }">
                    <strong class="error--text">{{ item.marca }}</strong>
                  </template>

                  <template v-slot:item.stock_actual="{ item }">
                    <strong>{{ item.stock_actual }}</strong>
                  </template>

                  <template v-slot:item.precio_unit_venta="{ item }">
                    <div class="text-right">
                      <span>{{ item.precio_unit_venta | formatearNumero }}</span>
                    </div>
                  </template>

                  <template v-slot:item.precios_ventas="{ item }">
                    <div class="text-right">
                      <template v-if="vts.nombre == 'precio_unit_venta'">
                        <strong>{{ item.precio_unit_venta | formatearNumero }}</strong>
                      </template>

                      <template v-if="vts.nombre == 'precio_unit_cliente'">
                        <strong>{{ item.precio_unit_cliente | formatearNumero }}</strong>
                      </template>

                      <template v-if="vts.nombre == 'precio_unit_distribuidor'">
                        <strong>{{ item.precio_unit_distribuidor | formatearNumero }}</strong>
                      </template>
                    </div>
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-row class="mt-0 mb-0">
                        <v-col cols="6" md="9" sm="4">
                          <v-text-field dense type="text" label="Descripción"
                            :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 10 && v.length <= 240) || 'Nombre debe tener entre 10 a 240 caracteres', Rules.unespacio]"
                            v-model.trim="item.descripcion_adicional" maxlength="200" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3" sm="4">
                          <v-select dense v-model="item.idtipo_afectacion" :items="tipo_afectacion"
                            label="Tipo Afectación" hide-details></v-select>
                        </v-col>
                      </v-row>
                      <template v-if="item.serie" class="mr-2">
                        <strong>SERIE:</strong>
                        {{ item.serie }}
                      </template>

                      <template v-if="esAdministrador">
                        <strong>Precio Compra:</strong>
                        <span>{{ item.idtipo_servicio == 3 ? "S/" : "$" }}
                          {{ item.precio_unit_compra.toFixed(2) | formatearNumero }}</span>
                        <template v-if="item.idtipo_servicio == 4">
                          <strong class="ml-2" v-if="esAdministrador">Precio Compra TC:</strong>
                          <span v-if="esAdministrador">S/ {{ (item.idtipo_servicio == 3 ? item.precio_unit_compra :
                            item.precio_unit_compra * tc).toFixed(2) | formatearNumero }}</span>
                        </template>
                        <br />
                      </template>
                      <strong>PROVEEDOR:</strong>
                      {{ item.proveedor.substring(0, 30) }}
                      <strong class="ml-4">FEC.INGRESO:</strong>
                      {{ item.fecha | formatearFecha }}
                      <strong>Pedido:</strong>
                      {{ item.idpedido }}
                    </td>
                  </template>
                </v-data-table>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Producto -->

        <ModalProducto :showDialog="dialogProduct" @closeProduct="dialogProduct = false"
          @dataSearch="dataSearchProduct" />

        <!--Modal sucursal stock -->
        <v-dialog v-model="verEstablecimientosProductos" max-width="1000px" persistent>
          <v-card>
            <v-toolbar dark dense class="primary mb-1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="openProduct">
                    <v-icon>playlist_add</v-icon>
                  </v-btn>
                </template>
                <span>Nuevo Producto</span>
              </v-tooltip>
              <v-autocomplete dense solo-inverted @keyup="selectProductos()"
                @change="listarStockEstablecimiento(idproducto), changeProductos(idproducto)"
                :search-input.sync="buscar_producto" :items="totalProductos" v-model="idproducto"
                label="Buscar Producto" :rules="[v => !!v || 'El producto es requerido']" prepend-inner-icon="category"
                required hide-details clearable>
              </v-autocomplete>

              <v-tooltip bottom v-if="esAdministrador || esAlmacenero">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon @click="addProduct()" :disabled="idproducto ? false : true">move_down</v-icon>
                  </v-btn>
                </template>
                <span>Agregar al Detalle de Compra</span>
              </v-tooltip>

              <v-btn icon @click="ocultarEstablecimientos()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-chip class="ma-1" label>
                Precio Unitario Venta: S/ {{ precioVenta | formatearNumero }}
              </v-chip>
              <v-chip class="ma-1" label>
                Cliente: S/ {{ precioCliente | formatearNumero }}
              </v-chip>
              <v-chip class="ma-1" label>
                Distribuidor: S/ {{ precioDistribuidor | formatearNumero }}
              </v-chip>
              <v-data-table :headers="cabeceraStockEstablecimiento" :items="stockEstablecimiento"
                class="elevation-3 ma-1" dense hide-default-footer>
                <template v-slot:item.stockactual="{ item }">
                  <template v-if="item.stockactual == stockMinimo">
                    <v-chip color="warning" small dark>{{ item.stockactual }}</v-chip>
                  </template>
                  <template v-else-if="item.stockactual > stockMinimo">
                    <v-chip color="success" small dark>{{ item.stockactual }}</v-chip>
                  </template>
                  <template v-else>
                    <v-chip color="error" small dark>{{ item.stockactual }}</v-chip>
                  </template>
                </template>
              </v-data-table>

            </v-card-text>
            <!-- Mostrar compra -->
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="primary--text text-center align-center"><strong>NUEVA
                    COMPRA</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ModalCompra v-if="dialogBuy" :changeIdProduct="idProduct" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- Mostrar compra -->
          </v-card>
        </v-dialog>
        <!-- Fin Modal sucursal stock -->

        <!-- Ventas -->
        <v-data-table :loading="loading" :headers="cabeceraListarVenta" :items="ventas" :items-per-page="15"
          item-key="idmovimiento" show-expand class="elevation-3" v-if="verNuevaVenta == 0 && verNuevaNotaCredito == 0"
          dense>

          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">VENTAS</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <v-spacer />
              <!-- Formulario busqueda de venta -->
              <v-text-field dense class="mr-1" v-model.trim="buscar" label="Búsqueda" @keyup="listar()" single-line
                hide-details></v-text-field>
              <v-spacer />
              <v-menu v-model="menuFecha" :close-on-content-click="!menuFecha" transition="scale-transition" offset-y
                min-width="290px" :close-on-click="dates.length == 2 ? true : false">
                <template v-slot:activator="{ on }">
                  <v-text-field dense v-model="dateRangeText" readonly v-on="on" hide-details append-icon="update"
                    @click:append="listar()" class="mr-1" style="max-width: 220px;"></v-text-field>
                </template>
                <v-date-picker v-model="dates" @input="dates.length == 2 ? menuFecha = false : menuFecha = true"
                  @change="listar()" range></v-date-picker>
              </v-menu>
              <div id="container" style="position: absolute; visibility: hidden;" class="qrcode" ref="qrCodeUrl"></div>
              <v-spacer />
              <!-- Fin Formulario busqueda de venta -->
              <v-btn @click="mostrarNuevaVenta" color="primary" class="hidden-sm-and-down" small outlined>Nuevo</v-btn>
              <v-btn @click="mostrarNuevaVenta" color="primary" class="hidden-md-and-up" fab x-small outlined>
                <v-icon>add</v-icon>
              </v-btn>

              <!-- Modal anular Venta -->
              <v-dialog v-model="adModal" max-width="300">
                <v-card>
                  <v-card-title class="justify-center">Anular: {{ adComprobante }}</v-card-title>
                  <v-card-text v-if="idtipo_comprobante != '00'">
                    <v-form v-model="isValid">
                      <v-text-field dense class="text-xs-center" v-model.trim="motivo" label="Motivo de anulación"
                        :rules="[v => !!v || 'El motivo es requerido', v => (v && v.length >= 5 && v.length <= 30) || 'El motivo debe tener de 5 a 30 caracteres', Rules.unespacio]"
                        maxlength="30" v-uppercase hide-details></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn color="info" class="white--text" @click="anularCerrar" small outlined>Cancelar</v-btn>
                    <v-btn color="error" class="white--text" :loading="desabilitar" :disabled="desabilitar || !isValid"
                      @click="anular()" small outlined>Anular</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal anular Venta -->

              <!-- Modal enviar email Venta -->
              <v-dialog v-model="adModalEmailCliente" max-width="500" persistent>
                <v-card>
                  <v-card-title class="text-h6">
                    {{ adComprobante }}
                    <v-spacer />
                    <v-btn icon @click="emailCerrar">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-subtitle class="justify-center">{{ cliente }}</v-card-subtitle>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-text-field dense class="text-xs-center" v-model.trim="email" label="Email"
                        :rules="[v => /.+@.+\..+/.test(v) || 'Ingrese un email valido', Rules.sinespacio]"
                        maxlength="60" v-lowercase hide-details></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn color="success" class="white--text" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" @click="enviarEmail()" small>
                      <v-icon left>send</v-icon>Enviar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal enviar email Venta -->
            </v-toolbar>
          </template>
          <!-- Opciones ventas -->

          <template v-slot:item.numero="{ item }">
            <template v-if="item.idtipo_comprobante != '00'">
              <strong>{{ item.serie_comprobante + "-" + item.num_comprobante }}</strong>
            </template>

            <template v-else>
              <span>{{ item.serie_comprobante + "-" + item.num_comprobante }}</span>
            </template>
          </template>

          <template v-slot:item.cliente="{ item }">
            <span>{{ (item.cliente).substr(0, 40) }}</span>
          </template>

          <template v-slot:item.fecha="{ item }">
            <span>{{ item.fecha | formatearFecha }}</span>
          </template>

          <template v-slot:item.moneda="{ item }">
            <div class="text-right">
              <strong>{{ item.moneda == "S" ? "S/" : "$" }}</strong>
            </div>
          </template>

          <template v-slot:item.importe_total="{ item }">
            <div class="text-right">
              <strong>{{ item.importe_total | formatearNumero }}</strong>
            </div>
          </template>

          <template v-slot:item.gratuito="{ item }">
            <div class="text-right">
              <span>{{ item.gratuito | formatearNumero }}</span>
            </div>
          </template>
          <!-- Estado comprobantes -->

          <template v-slot:item.estado="{ item }">
            <template v-if="item.estado == 'Aceptado'">
              <v-chip small color='success' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>

            <template v-else-if="item.estado == 'Enviado'">
              <span class="primary--text">{{ item.estado }}</span>
            </template>

            <template v-else-if="item.estado == 'Por enviar'">
              <v-chip small color='brown' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>

            <template v-else-if="item.estado == 'Por anular'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip small color='orange' class="white--text font-weight-bold" label @click="irAnulacion"
                    v-bind="attrs" v-on="on">{{
                      item.estado }}</v-chip>
                </template>
                <span>Ir a anulaciones</span>
              </v-tooltip>
            </template>

            <template v-else-if="item.estado == 'Rechazado'">
              <v-chip small color='error' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>

            <template v-else-if="item.estado == 'Anulado'">
              <v-chip small color='error' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>

            <template v-else>
              <span>{{ item.estado }}</span>
            </template>
          </template>
          <!-- Fin Estado comprobantes -->
          <!-- Descarga de XML y CDR -->

          <template v-slot:item.descargas="{ item }">
            <template
              v-if="item.idtipo_comprobante == '01' || item.idtipo_comprobante == '03' || item.idtipo_comprobante == '07'">
              <template
                v-if="item.idtipo_comprobante == '01' || item.idtipo_comprobante == '03' || item.idtipo_comprobante == '07'">
                <v-chip color="cyan" class="white--text" x-small @click="descargarXml(item)">XML</v-chip>
              </template>

              <template
                v-if="item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' && item.estado == 'Aceptado' | item.estado == 'Anulado'
                  || item.idtipo_comprobante == '07' && item.serie_comprobante.substring(0, 2) != 'BC' && item.estado == 'Aceptado' | item.estado == 'Anulado'">
                <v-chip color="teal" class="white--text" x-small @click="descargarCdr(item)">CDR</v-chip>
              </template>
            </template>
          </template>
          <!-- Fin Descarga de XML y CDR -->

          <!-- Opciones de impresion, anular y cpe-->
          <template v-slot:item.opciones="{ item }">
            <template
              v-if="item.idtipo_comprobante == '01' || item.idtipo_comprobante == '03' || item.idtipo_comprobante == '07'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon v-bind="attrs" v-on="on">
                    <v-icon color="info" @click="consultaValidezCPE(item)">task_alt</v-icon>
                  </v-btn>
                </template>
                <span>Consulta CPE</span>
              </v-tooltip>

            </template>

            <template v-if="item.idtipo_comprobante == '01' || item.idtipo_comprobante == '03'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon v-bind="attrs" v-on="on">
                    <v-icon color="indigo darken-1" @click="duplicarCPE(item)">file_copy</v-icon>
                  </v-btn>
                </template>
                <span>Duplicar CPE</span>
              </v-tooltip>
            </template>

            <v-btn small icon>
              <v-icon color="print" @click="mostrarComprobante(item)">print</v-icon>
            </v-btn>
            <!-- Anular Venta -->
            <template>
              <v-btn small icon
                v-if="item.idtipo_comprobante == '00' && item.estado == 'Creado' && item.ref_comprobante == '' && item.idusuario == usuario.idusuario ||
                  item.idtipo_comprobante == '01' && item.estado == 'Aceptado' && item.ref_comprobante.substring(0, 2) != '07' && item.idusuario == usuario.idusuario && item.dar_baja == 'S' ||
                  item.idtipo_comprobante == '03' && item.estado == 'Aceptado' && item.ref_comprobante.substring(0, 2) != '07' && item.idusuario == usuario.idusuario && item.dar_baja == 'S' ||
                  item.idtipo_comprobante == '07' && item.estado == 'Aceptado' && item.idusuario == usuario.idusuario && item.dar_baja == 'S'">
                <v-icon color="error" @click="anularMostrar(item), isValid = true">delete</v-icon>
              </v-btn>
            </template>
            <!-- Anular Venta -->

            <!-- Menu para mas opciones de FE -->
            <template v-if="item.idtipo_comprobante == '01' && item.estado == 'Aceptado' | item.estado == 'Creado'
              || item.idtipo_comprobante == '03' && item.estado == 'Aceptado' | item.estado == 'Creado'
              || item.idtipo_comprobante == '07' && item.estado == 'Aceptado' | item.estado == 'Creado'
              || item.idtipo_comprobante == '00' && item.estado == 'Creado'">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small icon>
                    <v-icon v-on="on" color="primary">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- Reenviar Sunat -->
                  <!-- <v-list-item link
                    v-if="item.idusuario == usuario.idusuario && item.estado == 'Creado' && item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' | item.idtipo_comprobante == '07' & item.ref_comprobante.substring(0, 2) != '03'"> -->
                  <v-list-item link :disabled="loadingEnvio || loadingCdr"
                    v-if="item.estado == 'Creado' && item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' | item.idtipo_comprobante == '07' & item.ref_comprobante.substring(0, 2) != '03'">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="reenviarSunat(item)">
                        <template v-if="loadingEnvio">
                          <v-progress-circular indeterminate color="primary" size="20" class="mr-2" />
                          Enviando...
                        </template>
                        <template v-else>
                          Enviar a la SUNAT
                        </template>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Fin Reenviar Sunat -->

                  <!-- Nota de Credito -->
                  <v-list-item link
                    v-if="item.estado == 'Aceptado' && item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' && item.ref_comprobante.substring(0, 2) != '07'">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="verDetallesNotaCredito(item)">Generar NOTA DE
                        CRÉDITO</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Fin Nota de Credito -->

                  <!-- Convertir en Comprobante -->
                  <v-list-item link
                    v-if="item.estado == 'Creado' && item.idtipo_comprobante == '00' && item.idtipo_documento == 6 && item.ref_comprobante == ''">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="convertirComprobante('01', item)">Convertir en
                        FACTURA</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link
                    v-if="item.estado == 'Creado' && item.idtipo_comprobante == '00' && item.idtipo_documento == 1 | item.idtipo_documento == 6 && item.ref_comprobante == ''">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="convertirComprobante('03', item)">Convertir en
                        BOLETA</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Convertir en Comprobante -->

                  <!-- Guia Remision -->
                  <v-list-item link
                    v-if="item.estado == 'Aceptado' | item.estado == 'Creado' && item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' | item.idtipo_comprobante == '00'">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="irGuiaRemision(item)">Generar GUÍA REMISIÓN
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Fin Guia Remision -->

                  <!-- Referencia -->
                  <v-list-item v-if="item.ref_comprobante != ''">
                    <v-list-item-content>
                      <v-list-item-title class="info--text">Referencia: {{ item.ref_comprobante.substring(3, 16) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Fin Referencia -->

                  <!-- Recuperar CDR -->
                  <v-list-item link :disabled="loadingCdr"
                    v-if="item.estado == 'Creado' && item.idtipo_comprobante == '01' | item.idtipo_comprobante == '03' | item.idtipo_comprobante == '07' && item.msj_cdr.split('-')[0] !== '0' && item.msj_cdr">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text" @click="consultarEstadoCDR(item)">
                        <template v-if="loadingCdr">
                          <v-progress-circular indeterminate color="primary" size="20" class="mr-2" />
                          Consultando CDR...
                        </template>
                        <template v-else>
                          Recuperar la CDR
                        </template>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Fin Recuperar CDR -->
                </v-list>
              </v-menu>
            </template>
            <!-- Fin Menu para mas opciones de FE -->
          </template>
          <!-- Fin Opciones de impresion, anular y cpe-->

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <strong>Registrado por:</strong>
              {{ item.usuario }}
              <br />
              <strong v-if="item.msj_cdr.length > 0">SUNAT:</strong>
              {{ item.msj_cdr }}
            </td>
          </template>
          <!-- Fin Opciones ventas -->
        </v-data-table>
        <!--Fin Ventas -->

        <!-- Nota de credito -->
        <v-card v-if="verNuevaNotaCredito == 1" class="elevation-3">
          <v-toolbar dark dense class="primary" flat>
            <v-toolbar-title>
              <v-tooltip bottom>

                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    @click="adicional == false ? adicional = true : adicional = false">
                    <v-icon>notes</v-icon>
                  </v-btn>
                </template>
                <span>Adicionales</span>
              </v-tooltip>Emitir Nota de Crédito</v-toolbar-title>
          </v-toolbar>
          <v-card-text grid-list-sm v-if="verNuevaNotaCredito">
            <v-form v-model="isValid">
              <v-row>
                <v-col cols="12" sm="4">
                  <v-select dense v-model="idtipo_nota_cred" :items="tipo_nota_creds"
                    @change="descripcionEmision(idtipo_nota_cred)" label="Motivo de Emisión"
                    :rules="[v => !!v || 'Motivo requerido']" hide-details></v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field dense v-model.trim="doc_ref" label="Ref. Comprobante" maxlength="20" v-uppercase
                    disabled hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select dense v-model="idpersona" :items="clientes" label="Cliente"
                    :rules="[v => !!v || 'El cliente es requerido']" hide-details></v-select>
                </v-col>

                <v-col cols="12">
                  <v-data-table :headers="cabeceraDetallesNC" :items="detalles" disable-pagination hide-default-footer
                    dense class="elevation-1">

                    <template v-slot:item.num="{ item }">
                      <td>{{ detalles.indexOf(item) + 1 }}</td>
                    </template>

                    <template v-slot:item.borrar="{ item }">
                      <v-icon small color="error" class="mr-2" @click="eliminarItemDetallePedido(detalles, item)"
                        :disabled="idtipo_nota_cred == '' ? true : idtipo_nota_cred != '07' ? true : false">
                        delete_forever</v-icon>
                    </template>

                    <template v-slot:item.stock_actual="{ item }">
                      <span class="font-weight-bold">{{ item.stock_actual }}</span>
                    </template>

                    <template v-slot:item.cantidad="{ item }">
                      <v-text-field dense type="text" @keyup.up="item.cantidad++" @keyup.down="item.cantidad--"
                        v-model="item.cantidad"
                        :rules="[v => (!!v && v > 0) || 'Requerido', item.cantidad <= item.cant_tope || 'Cantidad no puede ser > a stock']"
                        maxlength="6" hide-details class="center-input"
                        :disabled="idtipo_nota_cred == '' ? true : idtipo_nota_cred != '07' ? true : false"
                        @keypress="common.isNum($event)" onClick="this.select()"></v-text-field>
                    </template>

                    <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && v > 0 || 'Requerido']" maxlength="7" hide-details class="right-input"
                        disabled @keypress="common.numDec($event, item.precio_unit_venta, 4)"
                        onClick="this.select()"></v-text-field>
                    </template>
                    <!-- Se desabilita por el precio venta dolar es menor de precio de compra a <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && v > item.precio_unit_compra || 'Requerido']" maxlength="7" hide-details
                        class="right-input" disabled @keypress="common.numDec($event, item.precio_unit_venta, 4)"
                        onClick="this.select()"></v-text-field>
                    </template> -->

                    <!-- <template v-slot:item.descto_item="{ item }">
					          <span class="font-weight-bold">{{item.descto_item | formatearNumero }}</span>
                    </template>-->

                    <template v-slot:item.subtotal="{ item }">
                      <div class="text-right">
                        <span class="font-weight-bold">{{ (item.cantidad * item.precio_unit_venta) | formatearNumero
                          }}</span>
                      </div>
                    </template>
                  </v-data-table>
                  <v-container>
                    <v-row no-gutters align="end" justify="end">
                      <!-- <v-col cols="10" align="end">
                      <strong>Descuento Global (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        v-model="descto_global"
                        maxlength="7"
                        @keypress="common.numDec($event, descto_global, 4)" onClick="this.select()"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                      </v-col>-->
                      <!-- <v-col cols="10" align="end">
                      <strong>Descuento por Item (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        disabled
                        v-model="descto_item_total=common.roundOut(parseFloat(calcularDescuentoItem),2).toFixed(2)"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                      </v-col>-->
                      <v-col cols="8" align="end">
                        <strong>Gravada {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="subtotal_gravado = common.roundOut(common.valDec(importe_total) / (1 + igv), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>IGV {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="igv_gravado = common.roundOut(common.valDec(importe_total) - common.valDec(subtotal_gravado), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Importe Total {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="importe_total = common.roundOut(common.valDec(calcularTotal) - common.valDec(descto_global), 2).toFixed(2)"
                          :rules="[v => v > 0 || 'Importe mayor a cero']" class="right-input" hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Gratuita {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="gratuito = common.roundOut(calcularGratuitoTotal, 2).toFixed(2)" class="right-input"
                          hide-details></v-text-field>
                      </v-col>

                      <template v-if="adicional == true">
                        <v-col cols="3">
                          <v-text-field dense label="Placa" v-model="placa" maxlength="15" v-uppercase class="mr-1"
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field dense label="Observaciones" v-model="observacion" maxlength="50" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                      </template>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="py-0 pb-4 px-4 justify-center">
            <v-btn color="accent" @click="enviarNotaCreditoSunatBeta()" :loading="desabilitar"
              :disabled="desabilitar || !isValid" small icon v-if="datos.cpe == 'BETA'" outlined>
              <v-icon>done</v-icon>
            </v-btn>

            <v-btn color="error" @click="ocultarComprobanteNC()" small outlined>
              <v-icon left>close</v-icon>Cancelar
            </v-btn>
            <v-btn color="primary" @click="guardarNotaCredito()" :loading="desabilitar"
              :disabled="desabilitar || !isValid" small outlined>
              <v-icon left>check</v-icon>Crear N/C
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- Fin Nota de credito -->

        <!-- Nueva venta -->
        <v-card v-if="verNuevaVenta == 1" class="elevation-3">
          <v-toolbar dark dense class="primary" flat>
            <v-toolbar-title>
              <v-tooltip bottom>

                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    @click="adicional == false ? adicional = true : adicional = false">
                    <v-icon>notes</v-icon>
                  </v-btn>
                </template>
                <span>Adicionales</span>
              </v-tooltip> Nueva Venta</v-toolbar-title>
            <v-spacer />
            <v-text-field dense solo-inverted @keyup.enter="buscarCodigoBarra()" v-model="codigo_barra"
              @click:append="iniciarEscaneo" label="Código Barra" maxlength="30" append-icon="qr_code_scanner"
              style="max-width: 220px;" hide-details>
            </v-text-field>
          </v-toolbar>
          <v-card-text grid-list-sm v-if="verNuevaVenta">
            <v-form v-model="isValid">
              <v-row>
                <v-col cols="6" md="2" sm="3">
                  <v-select dense v-model="idtipo_servicio" :items="tipo_servicios" label="Moneda"
                    :rules="[v => !!v || 'Servicio requerido']" @change="detalles = []" :disabled="no_afecta"
                    hide-details></v-select>
                </v-col>
                <v-col cols="6" md="3" sm="3">
                  <v-select dense v-model="idtipo_comprobante" :items="tipo_comprobantes" label="Tipo Comprobante"
                    :rules="[v => !!v || 'Comprobante requerido']" @change="comprobanteSeleccionado(idtipo_comprobante)"
                    :disabled="no_afecta" hide-details></v-select>
                </v-col>
                <v-col cols="6" md="3" sm="3" v-if="!no_afecta">
                  <v-select dense v-model="idtipo_pago" :items="tipo_pagos" label="Tipo Pago"
                    :rules="[v => !!v || 'Tipo pago requerido']" @change="total_pago = common.valDec(importe_total)"
                    hide-details></v-select>
                </v-col>
                <v-col cols="6" md="2" sm="3">

                  <template>
                    <v-text-field dense type="text" v-model="total_pago" label="Importe TOTAL Pagado"
                      :prefix="idtipo_servicio == 5 ? 'S/' : '$'" maxlength="9"
                      :rules="[v => (!!v && parseFloat(v) >= parseFloat(importe_total).toFixed(2)) || 'El Importe no coincide']"
                      @keypress="common.numDec($event, total_pago, 2)" onClick="this.select()"
                      hide-details></v-text-field>
                  </template>
                </v-col>
                <v-col cols="5" md="2" sm="2">
                  <v-text-field dense
                    v-model="common.roundOut(common.valDec(total_pago) - common.valDec(importe_total), 2).toFixed(2)"
                    label="Diferencia - Vuelto" disabled hide-details></v-text-field>
                </v-col>
                <v-col cols="10" md="9" sm="9">
                  <v-autocomplete dense @keyup="selectCliente()" @change="changeCliente"
                    :search-input.sync="buscar_cliente" v-model="idpersona" :items="clientes" label="Cliente"
                    :rules="[v => !!v || 'El cliente es requerido']" clearable append-outer-icon="person_add"
                    @click:append-outer="mostrarPersona" :disabled="no_afecta" hide-details></v-autocomplete>
                </v-col>
                <v-spacer />
                <v-col cols="2" md="1" sm="1">
                  <div class="text-center" v-if="!no_afecta">
                    <v-btn @click="mostrarProductos()" x-small fab color="primary" outlined>
                      <v-icon>list</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="5" md="2" sm="3" v-if="idtipo_pago == 4 || idtipo_pago == 2 || idtipo_pago == 3">

                  <template v-if="idtipo_pago == 4">
                    <v-menu v-model="menuCalendario" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field dense v-model="fecha_vencimiento_formateada" label="Fecha Vencimiento" readonly
                          v-on="on" prepend-inner-icon="event" hide-details></v-text-field>
                      </template>
                      <v-date-picker v-model="fecha_vencimiento" @input="menuCalendario = false"
                        @change="fechaseleccionada(fecha_vencimiento)"></v-date-picker>
                    </v-menu>
                  </template>

                  <template v-if="idtipo_pago == 2 || idtipo_pago == 3">
                    <v-text-field dense v-model="num_operacion" label="Num. Operación"
                      :rules="[v => !!v || 'Numero Operación requerido']"
                      @blur.prevent="llenarCeroNumOperacion(num_operacion)" maxlength="10" hide-details></v-text-field>
                  </template>
                </v-col>

                <v-col cols="12">
                  <v-data-table :headers="cabeceraDetallesVenta" :items="detalles" disable-pagination
                    hide-default-footer dense class="elevation-1">

                    <template v-slot:item.num="{ item }">
                      <td>{{ detalles.indexOf(item) + 1 }}</td>
                    </template>

                    <template v-slot:item.borrar="{ item }">
                      <v-icon small color="error" @click="eliminarItemDetallePedido(detalles, item)"
                        :disabled="no_afecta">delete_forever</v-icon>
                    </template>

                    <template v-slot:item.stock_actual="{ item }">
                      <div class="text-center">
                        <span class="font-weight-bold">{{ item.stock_actual }}</span>
                      </div>
                    </template>

                    <template v-slot:item.cantidad="{ item }">
                      <v-text-field dense type="text" @keyup.up="item.cantidad++" @keyup.down="item.cantidad--"
                        v-model="item.cantidad"
                        :rules="[v => (!!v && v > 0) || 'Requerido', (!no_afecta ? item.stock_actual >= item.cantidad : item.cantidad == item.cantidad) || 'No valido']"
                        maxlength="6" hide-details class="center-input" :disabled="no_afecta"
                        @keypress="common.isNum($event)" onClick="this.select()">
                      </v-text-field>
                    </template>

                    <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && (datos.modpventa == 'SI' ? (v > 0) : (v > (idtipo_servicio == 5 ? item.precio_unit_compra : (item.precio_unit_compra / tc)))) || 'Requerido']"
                        maxlength="9" hide-details :disabled="no_afecta"
                        @keypress="common.numDec($event, item.precio_unit_venta, 4)"
                        onClick="this.select()"></v-text-field>
                    </template>
                    <!-- <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && v > 0 || 'Requerido']" maxlength="9" hide-details :disabled="no_afecta"
                        @keypress="common.numDec($event, item.precio_unit_venta, 4)"
                        onClick="this.select()"></v-text-field>
                    </template> -->
                    <!-- <template v-slot:item.descto_item="{ item }">
					          <span class="font-weight-bold">{{item.descto_item | formatearNumero }}</span>
                    </template>-->

                    <template v-slot:item.subtotal="{ item }">
                      <div class="text-right">
                        <span class="font-weight-bold">{{ (item.cantidad * item.precio_unit_venta - item.descto_item) |
                          formatearNumero
                          }}</span>
                      </div>
                    </template>
                  </v-data-table>
                  <v-container>
                    <v-row no-gutters align="end" justify="end">
                      <!-- <v-col cols="10" align="end">
                      <strong>Descuento Global (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        v-model="descto_global"
                        maxlength="7"
                        @keypress="common.numDec($event, descto_global, 2)" onClick="this.select()"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                      </v-col>-->
                      <!-- <v-col cols="10" align="end">
                      <strong>Descuento por Item (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        disabled
                        v-model="descto_item_total=common.roundOut(parseFloat(calcularDescuentoItem),2).toFixed(2)"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                      </v-col>-->
                      <v-col cols="8" align="end">
                        <strong>Gravada {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="subtotal_gravado = common.roundOut(common.valDec(importe_total) / (1 + igv), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>IGV {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="igv_gravado = common.roundOut(common.valDec(importe_total) - common.valDec(subtotal_gravado), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Importe Total {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense readonly @click="total_pago = common.valDec(importe_total)"
                          v-model="importe_total = common.roundOut(common.valDec(calcularTotal) - common.valDec(descto_global), 2).toFixed(2)"
                          :rules="[v => v > 0 || 'Importe mayor a cero']" class="right-input" hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Gratuita {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="gratuito = common.roundOut(calcularGratuitoTotal, 2).toFixed(2)" class="right-input"
                          hide-details></v-text-field>
                      </v-col>

                      <template v-if="adicional == true">
                        <v-col cols="3">
                          <v-text-field dense label="Placa" v-model="placa" maxlength="15" v-uppercase class="mr-1"
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field dense label="Observaciones" v-model="observacion" maxlength="50" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                      </template>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="py-0 pb-4 px-4 justify-center">
            <v-btn color="accent" @click="enviarDocumentoSunatBeta()" :loading="desabilitar"
              :disabled="desabilitar || !isValid || idtipo_comprobante == '00'" small icon v-if="datos.cpe == 'BETA'"
              outlined>
              <v-icon>done</v-icon>
            </v-btn>

            <v-btn color="error" @click="ocultarNuevaVenta()" small outlined>
              <v-icon left>close</v-icon>Cancelar
            </v-btn>
            <v-btn color="primary" @click="guardarVenta()" :loading="desabilitar" :disabled="desabilitar || !isValid"
              small outlined>
              <v-icon left>check</v-icon>Crear Venta
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- Fin Nueva venta -->

        <!--Modal impresión -->
        <v-dialog v-model="comprobanteModal" :max-width="datos.formatimpresion == '1' ? '450px' : '700px'" scrollable>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>{{ comprobante }}</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="printExternal()">
                <v-icon>print</v-icon>
              </v-btn>
              <!-- <v-btn icon @click="printExternalAlmac()">
                <v-icon>receipt</v-icon>
              </v-btn>-->
              <v-btn icon @click="emailMostrar()" v-if="idtipo_comprobante != '00'" :disabled="disableBMail">
                <v-icon>attach_email</v-icon>
              </v-btn>
              <v-btn icon @click="savePdf()">
                <v-icon>download</v-icon>
              </v-btn>
              <v-btn icon @click="ocultarComprobanteImp()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 400px;" class="px-0">
              <pdf :src="stringPdf"></pdf>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal impresión -->

        <v-snackbar v-model="snackbarCi" :timeout="timeout" :color="cis.color" max-width="720">
          <template v-if="cis.flgRpt == '0'">
            <h4 class="font-weight-bold text-center">{{ cis.respuesta }}</h4>
          </template>
          <template v-else>
            <h4 class="text-h6 font-weight-bold mb-2 text-center">{{ cis.respuesta }} {{ cis.cpe }}</h4>
            <v-row no-gutters>
              <v-col cols="6" class="font-weight-bold">Estado del comprobante a la fecha de la consulta </v-col>
              <v-col cols="6">: {{ cis.estadoCp }}</v-col>

              <v-col cols="6" class="font-weight-bold">Estado del contribuyente a la fecha de emisión</v-col>
              <v-col cols="6">: {{ cis.estadoRuc }}</v-col>

              <v-col cols="6" class="font-weight-bold">Condición de domicilio a la fecha de emisión</v-col>
              <v-col cols="6">: {{ cis.condDomiRuc }}</v-col>
            </v-row>
          </template>
          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbarCi = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import numeral from "numeral";
import moment from "moment";
import pdf from "vue-pdf";
import QRCode from "qrcodejs2";
import { BrowserMultiFormatReader } from '@zxing/library';
import { mapGetters, mapState, mapActions } from "vuex";
import ModalProducto from "./Modal_Producto.vue";
import ModalCompra from "./Modal_Compra.vue";

export default {
  components: {
    pdf,
    ModalProducto,
    ModalCompra
  },
  data() {
    return {
      ventas: [],
      cabeceraListarVenta: [
        { text: "...", value: "data-table-expand", align: "center" },
        { text: "NÚMERO", value: "numero", sortable: false, width: 143 },
        { text: "CLIENTE", value: "cliente", sortable: false },
        { text: "FECHA", value: "fecha", sortable: false },
        { text: "M", value: "moneda", sortable: false },
        { text: "IMPORTE", value: "importe_total", sortable: false },
        //{ text: "GRATUITO", value: "gratuito", sortable: false },
        { text: "PAGO", value: "descrip_pago", sortable: false },
        { text: "ESTADO", value: "estado", sortable: false, width: 100 },
        { text: "", value: "descargas", sortable: false },
        { text: "OPCIÓNES", value: "opciones", sortable: false, width: 160 },
      ],

      cabeceraDetallesVenta: [
        { text: "", value: "borrar", sortable: false },
        { text: "#", value: "num", sortable: false },
        //{ text: "CÓDIGO", value: "codigo_producto", sortable: false },
        { text: "DESCRIPCIÓN", value: "descripcion_adicional", sortable: false },
        { text: "STOCK", value: "stock_actual", sortable: false },
        { text: "CANT.", value: "cantidad", align: "center", sortable: false },
        { text: "PRECIO", value: "precio_unit_venta", sortable: false },
        //{ text: "DESCUENTO", value: "descto_item", sortable: false },
        { text: "TOTAL", value: "subtotal", sortable: false },
      ],

      cabeceraDetallesNC: [
        { text: "", value: "borrar", sortable: false },
        { text: "#", value: "num", sortable: false },
        { text: "DESCRIPCIÓN", value: "descripcion_adicional", sortable: false },
        { text: "STOCK", value: "stock_actual", sortable: false },
        { text: "CANTIDAD", value: "cantidad", sortable: false },
        { text: "PRECIO", value: "precio_unit_venta", sortable: false },
        //{ text: "DSCTO", value: "descto_item", sortable: false },
        { text: "TOTAL", value: "subtotal", sortable: false },
      ],

      cabeceraBusquedaProductos: [
        { text: "...", value: "data-table-expand", align: "center" },
        { text: "+", value: "seleccionar", align: "center", sortable: false },
        { text: "IMG", value: "imagen", align: "center", sortable: false },
        { text: "U/M", value: "idunidad_medida", sortable: false },
        { text: "CÓDIGOS", value: "codigos", sortable: false },
        { text: "NOMBRE", value: "descripcion", sortable: false },
        { text: "CATEGORÍA", value: "categoria", sortable: false },
        { text: "MARCA", value: "marca", sortable: false, divider: true },
        { text: "STOCK", value: "stock_actual", align: "center", sortable: false, divider: true },
        { text: "PRECIO S/", value: "precios_ventas", sortable: false },
      ],

      cabeceraStockEstablecimiento: [
        { text: "CdEt", value: "idsucursal", align: "center", sortable: false },
        { text: "ESTABLECIMIENTOS", value: "establecimiento", sortable: false, divider: true },
        { text: "STOCK", value: "stockactual", align: "center", sortable: false },
      ],

      loading: false,
      loadingEnvio: false,
      loadingCdr: false,
      // Escaner barra
      dialogCamara: false,
      lector: null,
      escaneando: false,

      // Consulta integrada CPE
      loadingValida: false,
      snackbarCi: false,
      timeout: 10000,
      cis: {
        respuesta: "",
        flgRpt: "",
        cpe: "",
        estadoCp: "",
        estadoRuc: "",
        condDomiRuc: "",
        color: ""
      },

      detalles: [], // Detalles pedido
      detalle_pedidos: [], // Detalles formateado
      detalleCuentasxC: [],
      productos: [],
      buscar: "",
      buscar_cliente: "",
      buscar_ubigeo: "",
      codigo_barra: "",

      idmovimiento: "",
      idpedido: 0,

      sucursal: "",
      cliente: "",
      fecha: "",
      num_documento: "",
      importe_letras: "",
      direccion: "",
      telefono: "",
      email: "",
      comprobante: "",
      serie_comprobante: "",
      num_comprobante: "",
      moneda: "",
      igv: 0,

      placa: "",
      observacion: "",
      descto_global: 0,
      descto_item_total: 0,
      subtotal_gravado: 0,
      gratuito: 0,
      igv_gravado: 0,
      importe_total: 0,

      ref_comprobante: "",
      afecta_stock: "",

      idtipo_documento: "",
      idpersona: "",
      clientes: [],

      idtipo_servicio: 5, // Venta Soles
      tipo_servicios: [],

      total_pago: 0,
      num_operacion: "",
      // Ventas
      verProductos: 0,
      brDescripcion: "",
      selectedZoom: false,
      imagen_zoom: "",
      tc: 0,

      verEstablecimientosProductos: 0,
      buscar_producto: "",
      idproducto: "",
      totalProductos: [],

      stockEstablecimiento: [],
      precioVenta: "",
      precioCliente: "",
      precioDistribuidor: "",
      stockMinimo: "",

      verNuevaVenta: 0,
      idtipo_pago: "",
      tipo_pagos: [],
      idtipo_comprobante: "", // 00=Recibo Interno, 01=Factura, 03=Boleta de Venta
      tipo_comprobantes: [],
      iddetalle_comprobante_sucursal: "",

      fecha_vencimiento_formateada: "",
      fecha_vencimiento: moment().format("YYYY-MM-DD"),
      fecha_actual: moment().format("YYYY-MM-DD"),

      menuCalendario: false,
      // Fin Ventas

      comprobanteModal: 0,
      verNuevaNotaCredito: 0,

      adicional: false,
      desabilitar: false,
      isValid: true, // Validamos
      isValidP: true,

      disableBMail: true,

      adModal: 0,
      adComprobante: 0,
      motivo: "",

      no_afecta: false,

      adModalEmailCliente: 0,

      stringPdf: "",
      blobPdf: "",

      doc_ref: "", // Numero de comprobante FE referencia
      cod_doc_ref: "", // Codigo de tipo documento FE referencia

      idtipo_nota_cred: "",
      tipo_nota_creds: [],

      // Persona
      nombre: "",
      idtipo_documento_pers: "",
      tipo_documentos_cli: [],
      num_documento: "",
      idubigeo: "", // select ubigeos
      ubigeos: [],
      direccion: "",
      telefono: "",
      email: "",
      verPersona: false,
      desabilitarBuscar: false,
      desabilitarPer: false,
      isValidPer: true,
      // Persona
      tipo_afectacion: [],

      dialogProduct: false,
      dialogBuy: false,
      idProduct: "",

      vts: {
        nombre: "precio_unit_venta",
        ventas: [
          { text: "Venta", value: "precio_unit_venta" },
          { text: "Cliente", value: "precio_unit_cliente" },
          { text: "Distribuidor", value: "precio_unit_distribuidor" },
        ],
      },

      dates: [
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD"),
      ],
      menuFecha: false,

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapState(["usuario", "datos", "logo"]),
    ...mapGetters(["esAdministrador", "esCaja"]),

    dateRangeText() {
      let fechaIni;
      let fechaFin;
      for (var i = 0; i < this.dates.length; i++) {
        fechaIni = this.common.formatDate(this.dates[0]);
        fechaFin = this.common.formatDate(this.dates[1]);
      }
      let arrayFechas = [fechaIni, fechaFin];
      return arrayFechas.join(" ~ ");
    },

    calcularTotal: function () {
      let me = this;
      var resultado = 0.0;
      for (var i = 0; i < me.detalles.length; i++) {
        if (me.detalles[i].idtipo_afectacion == "10") {
          resultado = resultado + me.common.roundOut(me.common.valInt(me.detalles[i].cantidad) * me.common.valDec(me.detalles[i].precio_unit_venta) - me.common.valDec(me.detalles[i].descto_item), 2);
        }
      }
      return resultado;
    },

    calcularGratuitoTotal: function () {
      let me = this;
      var resultado = 0.0;
      for (var i = 0; i < me.detalles.length; i++) {
        if (me.detalles[i].idtipo_afectacion == "31") {
          resultado = resultado + me.common.roundOut(me.common.valInt(me.detalles[i].cantidad) * me.common.valDec(me.detalles[i].precio_unit_venta) - me.common.valDec(me.detalles[i].descto_item), 2);
        }
      }
      return resultado;
    },

    calcularDescuentoItem: function () {
      let me = this;
      var resultado = 0.0;
      for (var i = 0; i < me.detalles.length; i++) {
        resultado = resultado + me.common.roundOut(me.common.valDec(me.detalles[i].descto_item), 2);
      }
      return resultado;
    },
  },

  watch: {
    comprobanteModal(val) {
      val || this.ocultarComprobanteImp();
    },
    verProductos(val) {
      val || this.ocultarProductos();
    },
    brDescripcion(newVal) {
      if (newVal === null) {
        this.brDescripcion = "";
      }
    },
  },

  created() {
    this.igv = parseFloat(this.datos.igv);
    this.tc = parseFloat(this.datos.tc);
    this.fechaseleccionada(this.fecha_vencimiento);
    this.listar();
    this.select();
  },

  methods: {
    ...mapActions(["snackBar", "cargarNotifCpes"]),

    openProduct() {
      this.dialogProduct = true
    },

    async dataSearchProduct(data) {
      this.idproducto = data.idproduct;
      this.buscar_producto = data.description;
      await this.selectProductos();
      this.changeProductos(data.idproduct);
      this.listarStockEstablecimiento(data.idproduct)
    },

    addProduct() {
      this.idProduct = this.idproducto
    },

    fechaseleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_vencimiento_formateada = ddmmyy;
    },

    //#region VENTAS
    listar(printid) {
      let me = this;
      me.loading = true;

      let adVenta = this.$route.params.adventa;
      let dePedido = this.$route.params.depedido; // true
      let deidtipo_servicio = this.$route.params.deidtipo_servicio;
      let deidpersona = this.$route.params.deidpersona;
      let deidpedido = this.$route.params.deidpedido;

      if (adVenta === true) {
        me.verNuevaVenta = 1;
        me.$route.params.adventa = false;
      }

      if (dePedido == true) {
        me.idtipo_servicio = deidtipo_servicio;
        me.idpersona = deidpersona;
        me.selectCliente(deidpersona);
        me.idpedido = deidpedido;
        me.listarDetallePedidos(deidpedido);
        me.verNuevaVenta = 1;
        me.$route.params.depedido = false;
      }

      if (me.buscar == "") {
        axios.get("api/Movimientos/ListarVenta", {
          params: {
            idsucursal: parseInt(me.usuario.idsucursal),
            idusuario: parseInt(me.usuario.idusuario),
            buscar: me.buscar == "" ? "-" : me.buscar,
            fechaInicio: me.dates[0],
            fechaFin: me.dates[1] == undefined ? me.dates[0] + " 23:59:59" : me.dates[1] + " 23:59:59",
          },
        })
          .then(function (response) {
            me.ventas = response.data;
            me.loading = false;
            if (printid) {
              me.cargaComprobante(printid);
            }
            me.cargarNotifCpes();// Actualizamos Notificacion Cpes
          })
          .catch(function (error) {
            //console.log(error);
          });
      } else {
        axios.get("api/Movimientos/ListarVentaTotal", {
          params: {
            idsucursal: parseInt(me.usuario.idsucursal),
            buscar: me.buscar == "" ? "-" : me.buscar,
            fechaInicio: me.dates[0],
            fechaFin: me.dates[1] == undefined ? me.dates[0] + " 23:59:59" : me.dates[1] + " 23:59:59",
          },
        })
          .then(function (response) {
            me.ventas = response.data;
            me.loading = false;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },

    irAnulacion() {
      this.$router.push({ name: "baja" }).catch(() => { });
    },

    irGuiaRemision(item) {
      this.$router.push({
        name: "guias_remision",
        params: {
          venta: true,
          idmovimientoventa: item.idmovimiento,
          idpersonaventa: item.idpersona,
          idpedidoventa: item.idpedido,
          numero: item.serie_comprobante + "-" + item.num_comprobante,
          idmotivotraslado: "01",
          mottraslado: "VENTA"
        },
      });
    },

    reenviarSunat(item) {
      let me = this;
      me.loadingEnvio = true;

      if (item.idtipo_comprobante == "01" | item.idtipo_comprobante == "03") {
        axios.put("api/Movimientos/ReenviarVentaSunat/" + item.idmovimiento)

          .then(function (response) {
            me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
            me.loadingEnvio = false;
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.loadingEnvio = false;
          });
      } else if (item.idtipo_comprobante == "07") {
        axios.put("api/Movimientos/ReenviarNotaCreditoSunat/" + item.idmovimiento)
          .then(function (response) {
            me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
            me.loadingEnvio = false;
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.loadingEnvio = false;
          });
      } else {
        // console.log("error"); // No es Factura ni Nota de credito
      }
    },

    consultarEstadoCDR(item) {
      let me = this;
      me.loadingCdr = true;
      axios.put("api/Movimientos/GetStatusCDR/" + item.idmovimiento)
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
          me.loadingCdr = false;
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    enviarDocumentoSunatBeta() {
      let me = this;
      if (me.idtipo_comprobante == "00") { // 0='Recibo Interno'
        return me.snackBar({ cl: "warning", msg: "El Comprobante no es valido para enviar a Sunat Beta." });
      }
      me.desabilitar = true;
      me.detalle_pedidos = []; // Limpiamos array para llenarlo
      me.convertirDetalleCPE(); // Actualizamos datos en detalle_pedidos para venta

      axios.post("api/Movimientos/EnviarSunatBeta", {
        // Para actualizar detalle_documento_sucursal
        idsucursal: parseInt(me.usuario.idsucursal),
        iddetalle_comprobante_sucursal: me.iddetalle_comprobante_sucursal,
        idtipo_servicio: me.idtipo_servicio,
        subtotal_gravado: parseFloat(me.subtotal_gravado),
        gratuito: parseFloat(me.gratuito),
        igv_gravado: parseFloat(me.igv_gravado),
        importe_total: parseFloat(me.importe_total),
        placa: me.placa,
        observacion: me.observacion,
        idtipo_comprobante: me.idtipo_comprobante, // boleta = 01 o factura = 03
        // Datos del Cliente Receptor
        idpersona: me.idpersona, // NRO_DOCUMENTO_CLIENTE, RAZON_SOCIAL_CLIENTE, DIRECCION_CLIENTE
        idtipo_documento: me.idtipo_documento, // 1 = dni, 6 = ruc
        // Detalle de nuestra FE
        detalle_pedidos: me.detalle_pedidos,
      })
        .then(function (response) {
          me.desabilitar = false;
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
        })
        .catch(function (error) {
          me.desabilitar = false;
          me.snackBar({ cl: "error", msg: error.response.data }); // Error de Pc
        });
    },

    guardarVenta() {
      let me = this;

      // Validamos si el detalle de pedido esta vacio
      if (me.detalles.length <= 0) { return me.snackBar({ cl: "warning", msg: "Ingrese al menos un producto al detalle." }); }
      if (me.detalles.length > 30) { return me.snackBar({ cl: "warning", msg: "El detalle solo acepta hasta 30 items." }); }
      // Validamos que la fecha de vencimiento sea mayor a la fecha actual
      if (me.idtipo_pago == 4 && Date.parse(me.fecha_vencimiento) <= Date.parse(me.fecha_actual)) {
        return me.snackBar({ cl: "warning", msg: "Modificar la fecha de vencimiento." });
      }
      // Si total_pago es menor al importe_total rechazamos
      if (parseFloat(me.total_pago) - parseFloat(me.importe_total) < 0) { return me.snackBar({ cl: "warning", msg: "Verifique el importe." }); }

      me.desabilitar = true;
      me.detalle_pedidos = [];
      me.convertirDetalleCPE();

      axios.post("api/Movimientos/CrearVenta", {
        idsucursal: parseInt(me.usuario.idsucursal),
        idpersona: me.idpersona, //FE
        idusuario: parseInt(me.usuario.idusuario),
        idpedido: me.idpedido,
        idtipo_servicio: me.idtipo_servicio, // FE
        num_operacion: me.idtipo_pago == 2 ? me.num_operacion : me.idtipo_pago == 3 ? me.num_operacion : "",
        idtipo_comprobante: me.idtipo_comprobante, // boleta = 01 o factura = 03
        igv: parseFloat(me.igv),
        descto_global: 0,
        descto_item_total: 0,
        otros_item_total: 0,
        seguro: 0,
        inafecto: 0,
        exonerado: 0,
        gratuito: parseFloat(me.gratuito),
        subtotal_gravado: parseFloat(me.subtotal_gravado),
        igv_gravado: parseFloat(me.igv_gravado),
        importe_total: parseFloat(me.importe_total),
        efectivo: me.idtipo_pago == 1 ? parseFloat(me.total_pago) : 0,
        placa: me.placa,
        observacion: me.observacion,
        detalle_pedidos: me.detalle_pedidos,
        fecha_vencimiento: me.fecha_vencimiento, // Fecha pago credito
        idtipo_pago: me.no_afecta == true ? 6 : me.idtipo_pago, // 6 = Contado - Ninguno
        afecta_stock: me.no_afecta == true ? "N" : "S",
        ref_comprobante: me.no_afecta == true ? me.cod_doc_ref + "-" + me.doc_ref : "",
        idrecibo_interno: me.no_afecta == true ? me.idmovimiento : 0,
        // Comprobantes ultima_serie, ultimo_numero
        iddetalle_comprobante_sucursal: me.iddetalle_comprobante_sucursal,
      })
        .then(function (response) {
          me.ocultarNuevaVenta();
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta });
          var printid = response.data.idmovimiento;
          me.listar(printid);
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
          me.listar(); // Si sale error se actualiza pedido deberia ir a ventas
        });
    },

    convertirComprobante(num, item) {
      let me = this;
      me.idmovimiento = item.idmovimiento; // RI
      me.idtipo_servicio = item.idtipo_servicio;
      me.no_afecta = true;
      me.doc_ref = item.serie_comprobante + "-" + item.num_comprobante;
      me.cod_doc_ref = item.idtipo_comprobante; // boleta = 03 o factura = 01
      me.idtipo_comprobante = num;
      me.comprobanteSeleccionado(num);
      me.idpersona = item.idpersona;
      me.total_pago = item.importe_total.toFixed(2);
      me.selectCliente(item.idpersona);
      me.listarDetallePedidos(item.idpedido);
      me.verNuevaVenta = 1;
    },

    mostrarNuevaVenta() {
      this.verNuevaVenta = 1;
    },

    ocultarNuevaVenta() {
      this.verNuevaVenta = 0;
      this.desabilitar = false; // Habilitamos boton guardar venta
      this.limpiar();
    },

    convertirDetalleCPE() {
      let me = this;
      for (var i = 0; i < me.detalles.length; i++) {
        me.detalle_pedidos.push({
          idproducto: me.detalles[i].idproducto,
          iddetalle_compra: me.detalles[i].iddetalle_compra,
          idunidad_medida: me.detalles[i].idunidad_medida,
          cantidad: parseInt(me.detalles[i].cantidad),
          // Validamos si es Gravado
          valor_unit_venta: me.detalles[i].idtipo_afectacion == "10" ? me.common.roundOut(parseFloat(me.detalles[i].precio_unit_venta) / (1 + me.igv), 4) : 0,
          precio_unit_venta: parseFloat(me.detalles[i].precio_unit_venta),
          descto_item: me.common.valDec(me.detalles[i].descto_item),
          //Validamos si es Gravado
          valor_venta: me.detalles[i].idtipo_afectacion == "10" ? me.common.roundOut((parseInt(me.detalles[i].cantidad) * parseFloat(me.detalles[i].precio_unit_venta)) / (1 + me.igv), 2) : 0,
          precio_venta: me.common.roundOut(parseInt(me.detalles[i].cantidad) * parseFloat(me.detalles[i].precio_unit_venta), 2),
          igv: me.igv * 100, // FE 18%
          codigo_producto: me.detalles[i].codigo_producto, // FE
          descripcion_adicional: me.detalles[i].descripcion_adicional,
          idprod_sunat: me.detalles[i].idprod_sunat, // FE
          idtipo_afectacion: me.detalles[i].idtipo_afectacion,
        });
      }
    },

    descargarXml(item) {
      let me = this;

      axios.get("api/Movimientos/DescargarXml/" + item.idmovimiento)
        .then(function (response) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", me.datos.ruc + "-" + item.idtipo_comprobante + "-" + item.serie_comprobante + "-" + item.num_comprobante + ".xml");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    descargarCdr(item) {
      let me = this;

      axios.get("api/Movimientos/DescargarCdr/" + item.idmovimiento)
        .then(function (response) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "R-" + me.datos.ruc + "-" + item.idtipo_comprobante + "-" + item.serie_comprobante + "-" + item.num_comprobante + ".xml");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    consultaValidezCPE(item) {
      let me = this;
      me.loadingValida = true;

      axios.get("api/Movimientos/SendConsultaIntegradaCPE", {
        params: {
          idmovimiento: item.idmovimiento,
        },
      })
        .then(function (response) {
          me.loadingValida = false;
          me.snackbarCi = true;
          Object.assign(me.cis, {
            respuesta: response.data.respuesta,
            flgRpt: response.data.flg_rpt,
            cpe: response.data.cpe,
            estadoCp: response.data.estadoCp,
            estadoRuc: response.data.estadoRuc,
            condDomiRuc: response.data.condDomiRuc,
            color: response.data.rptcolor
          });
        })
        .catch(function (error) {
          me.loadingValida = false;
          me.snackBar({ cl: response.data.rptcolor, msg: error.response.data });
        });
    },

    anular() {
      let me = this;
      me.desabilitar = true;

      if (me.idtipo_comprobante == "00") {
        axios.put("api/Movimientos/AnularVenta/" + me.idmovimiento + "/" + me.usuario.idsucursal + "/" + me.usuario.idusuario)
          .then(function (response) {
            me.snackBar({ cl: "success", msg: response.data });
            me.anularCerrar();
            me.listar();
          })
          .catch(function (error) {
            //console.log(error);
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else if (me.idtipo_comprobante == "03" || me.idtipo_comprobante == "07" && me.adComprobante.substring(0, 1) == "B") {
        axios.put("api/Movimientos/CrearResumenBaja", {
          idmovimiento: me.idmovimiento,
          idsucursal: parseInt(me.usuario.idsucursal),
          idusuario: parseInt(me.usuario.idusuario),
          motivo: me.motivo,
        })
          .then(function (response) {
            me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
            me.anularCerrar();
            me.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else if (me.idtipo_comprobante == "01" || me.idtipo_comprobante == "07" && me.adComprobante.substring(0, 1) == "F") {
        axios.put("api/Movimientos/CrearComunicacionBaja", {
          idmovimiento: me.idmovimiento,
          idsucursal: parseInt(me.usuario.idsucursal),
          idusuario: parseInt(me.usuario.idusuario),
          motivo: me.motivo,
        })
          .then(function (response) {
            me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
            me.anularCerrar();
            me.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else {
        me.snackBar({ cl: "error", msg: "Hubo un error" });
        me.listar();
      }
    },

    /* Anular */
    anularMostrar(item) {
      this.adModal = 1;
      this.idmovimiento = item.idmovimiento;
      this.adComprobante = item.serie_comprobante + "-" + item.num_comprobante;
      this.idtipo_comprobante = item.idtipo_comprobante;
    },

    anularCerrar() {
      this.adModal = 0;
      this.idmovimiento = "";
      this.idtipo_comprobante = "";
      this.desabilitar = false;
      this.motivo = "";
      this.limpiar();
    },
    /* Fin Anular */

    llenarCeroNumOperacion(num_operacion) {
      this.num_operacion = ("0000000000" + num_operacion).slice(-10);
    },

    duplicarCPE(item) {
      this.idmovimiento = item.idmovimiento;
      this.idtipo_pago = item.idtipo_pago;
      this.idtipo_servicio = item.idtipo_servicio;
      this.idtipo_comprobante = item.idtipo_comprobante;
      this.comprobanteSeleccionado(item.idtipo_comprobante);
      this.serie_comprobante = item.serie_comprobante;
      this.num_comprobante = item.num_comprobante;
      this.gratuito = item.gratuito;
      this.total_pago = item.efectivo;
      this.placa = item.placa;
      this.observacion = item.observacion;
      this.listarDetallePedidos(item.idpedido); // Solo listamos detalles
      this.idpersona = item.idpersona;
      this.selectCliente(this.idpersona);
      this.verNuevaVenta = 1;
    },
    //#endregion VENTAS

    //#region PRODUCTO
    buscarCodigoBarra() {
      let me = this;

      axios.get("api/Pedidos/BuscarCodigoBarraVenta/" + parseInt(me.usuario.idsucursal) + "/" + me.codigo_barra)
        .then(function (response) {
          //console.log(response);
          me.agregarDetalle(response.data);
          me.snackBar({ cl: "info", msg: "Se agrego " + response.data.descripcion + " al detalle." });
          //me.codigo_barra = "";
        })
        .catch(function (error) {
          //console.log(error);
          me.snackBar({ cl: "warning", msg: "No hay registro de compra para el producto." });
          //me.codigo_barra = "";
        });
    },

    listarProductoBuscar() {
      let me = this;

      axios.get("api/Pedidos/ListarProductoVenta", {
        params: {
          idsucursal: parseInt(me.usuario.idsucursal),
          descripcion: me.brDescripcion == "" ? "-" : me.brDescripcion,
        },
      })
        .then(function (response) {
          me.productos = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    dblClickRepuesto(event, { item }) {
      this.agregarDetalle(item);
    },

    agregarDetalle(data = []) {
      let me = this;
      // Buscar el índice del detalle existente con el mismo iddetalle_compra
      const indiceExistente = me.detalles.findIndex(detalle => detalle.iddetalle_compra === data["iddetalle_compra"]);

      if (indiceExistente !== -1) {
        // Si el detalle ya existe, sumar la cantidad
        me.detalles[indiceExistente].cantidad += 1;
      } else {
        me.detalles.push({
          idproducto: data["idproducto"],
          iddetalle_compra: data["iddetalle_compra"],
          codigo_producto: data["codigo_producto"], // FE
          //categoria: data["categoria"],
          //marca: data["marca"],
          idtipo_afectacion: data["idtipo_afectacion"],
          descripcion_adicional: data["descripcion_adicional"],
          stock_actual: data["stock_actual"],
          idunidad_medida: data["idunidad_medida"],
          cantidad: 1,
          valor_unit_venta: 0,
          precio_unit_venta: me.idtipo_servicio == 5 ? me.common.roundOut(data[me.vts.nombre], 2) : me.common.roundOut((data[me.vts.nombre] / me.tc), 2), // Capturamos el precio seleccionado
          descto_item: 0,
          valor_venta: 0,
          precio_venta: 0,
          idprod_sunat: data["idprod_sunat"],
          precio_unit_compra: me.common.roundOut((data["idtipo_servicio"] == 3 ? data["precio_unit_compra"] : data["precio_unit_compra"] * me.tc), 2) // > compra
        });
      }
    },

    mostrarProductos() {
      this.verProductos = 1;
    },

    ocultarProductos() {
      this.verProductos = 0;
      this.productos = [];
      this.imagen_zoom = "";
      this.brDescripcion = "";
      // limpiamos variables de buscar producto en establecimientos
      this.idproducto = "";
      this.buscar_producto = "";
      this.precioVenta = 0;
      this.precioCliente = 0;
      this.precioDistribuidor = 0;
      //this.totalProductos = [];
      this.stockEstablecimiento = [];
      this.stockMinimo = 1;
    },

    verImagen(item) {
      this.imagen_zoom = item.imagen;
      this.selectedZoom = true;
    },

    changeProductos(id) {
      this.precioVenta = 0;
      this.precioCliente = 0;
      this.precioDistribuidor = 0;
      this.stockMinimo = 1;

      if (id != null) {
        const selectId = this.totalProductos.find(
          (elemento) => elemento.value === id
        );
        this.precioVenta = selectId.precioVenta;
        this.precioCliente = selectId.precioCliente;
        this.precioDistribuidor = selectId.precioDistribuidor;
        this.stockMinimo = selectId.stockMinimo;
      }
    },

    // Buscar productos
    async selectProductos() {
      let me = this;
      let productosArray = []; // Limpiamos para cargar nuevamente

      try {
        const response = await axios.get("api/Productos/SelectBuscar", {
          params: {
            buscar: me.buscar_producto || "-"
          },
        })

        productosArray = response.data;
        productosArray.map(function (x) {
          me.totalProductos.push({ text: x.codigo_producto + " " + x.descripcion + " " + x.categoria + " " + x.marca, value: x.idproducto, precioVenta: x.precio_unit_venta, precioCliente: x.precio_unit_cliente, precioDistribuidor: x.precio_unit_distribuidor, stockMinimo: x.stock_minimo });
        });

      } catch (error) {
        //console.log(error);
      };

    },

    listarStockEstablecimiento(id) {
      let me = this;

      axios.get("api/Productos/ListarStockEstablecimiento", {
        params: {
          idproducto: id
        },
      })
        .then(function (response) {
          me.stockEstablecimiento = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    mostrarEstablecimientos() {
      this.verEstablecimientosProductos = 1;
      this.dialogBuy = true;
    },
    ocultarEstablecimientos() {
      this.verEstablecimientosProductos = 0;
    },
    //#endregion PRODUCTO

    //#region SELECT
    descripcionEmision(valor) {
      if (valor != null) {
        const selectId = this.tipo_nota_creds.find(
          (elemento) => elemento.value === valor
        );
        this.motivo = selectId.text;
      }
    },

    comprobanteSeleccionado(idtipo_comprobante) {
      if (idtipo_comprobante != null) {
        const selectId = this.tipo_comprobantes.find(
          (elemento) => elemento.value === idtipo_comprobante
        );
        this.iddetalle_comprobante_sucursal =
          selectId.iddetalle_comprobante_sucursal;
      }
      if (this.idtipo_comprobante == "01") {
        if (this.idtipo_documento == 6) {
          //console.log("comprobante valido para factura");
        } else {
          this.clientes = [];
          this.idpersona = "";
        }
      }
      // Si es Recibo Interno igv = 0 de lo contrario igv=0.18
      this.idtipo_comprobante == "00" // Recibo Interno
        ? (this.igv = 0)
        : (this.igv = parseFloat(this.datos.igv));
    },

    changeCliente(valor) {
      if (valor != null) {
        const selectId = this.clientes.find(
          (elemento) => elemento.value === valor
        );
        this.idtipo_documento = selectId.tipo_documento;
        //console.log(this.idtipo_documento) // mostrar que tipo documento de cliente 1 ó 6
      }
    },

    selectCliente(id) {
      let me = this;

      var clientesArray = [];

      if (id) {
        axios.get("api/Personas/SelectPersonas/" + id)
          .then(function (response) {
            clientesArray = response.data;
            clientesArray.map(function (x) {
              me.clientes.push({
                text: x.num_documento + " " + x.nombre + " |" + x.distrito + " - " + x.direccion,
                value: x.idpersona,
                tipo_documento: x.idtipo_documento,
              });
            });
          })
          .then((data) => {
            me.changeCliente(id);
          })
          .catch(function (error) {
            //console.log(error);
          });
      } else {
        axios.get("api/Personas/SelectPersonasFiltro", {
          params: {
            buscar:
              me.buscar_cliente == "" ? "-" : me.buscar_cliente == null ? "-" : me.buscar_cliente,
            tipo_doc: me.idtipo_comprobante == "" ? "-" : me.idtipo_comprobante == null ? "-" : me.idtipo_comprobante == "01" ? "RUC" : "-",
          },
        })
          .then(function (response) {
            clientesArray = response.data;
            clientesArray.map(function (x) {
              me.clientes.push({
                text: x.num_documento + " " + x.nombre + " |" + x.distrito + " - " + x.direccion,
                value: x.idpersona,
                tipo_documento: x.idtipo_documento,
              });
            });
          })
          .then((data) => {
            me.changeCliente(id); // En observacion
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },

    selectUbigeo(id) {
      let me = this;
      var ubigeosArray = [];

      if (id) {
        axios.get("api/Ubigeos/SelectUbigeos/" + id)
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        axios.get("api/Ubigeos/SelectUbigeosFiltro", {
          params: {
            buscar:
              me.buscar_ubigeo == ""
                ? "-"
                : me.buscar_ubigeo == null
                  ? "-"
                  : me.buscar_ubigeo,
          },
        })
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      }
    },

    select() {
      let me = this;

      var tipo_serviciosArray = [];
      axios.get("api/Tipo_Servicios/SelectMonVenta")
        .then(function (response) {
          tipo_serviciosArray = response.data;
          tipo_serviciosArray.map(function (x) {
            me.tipo_servicios.push({
              text: x.nombre,
              value: x.idtipo_servicio,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_comprobantesArray = [];
      axios.get("api/Detalle_Comprobante_Sucursales/SelectDetalleComprobanteSucursales/" + parseInt(me.usuario.idsucursal))
        .then(function (response) {
          tipo_comprobantesArray = response.data;
          tipo_comprobantesArray.map(function (x) {
            me.tipo_comprobantes.push({
              text: x.comprobante,
              value: x.idtipo_comprobante,
              iddetalle_comprobante_sucursal: x.iddetalle_comprobante_sucursal,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_documentosArray = [];
      axios.get("api/Tipo_Documentos/Select")
        .then(function (response) {
          tipo_documentosArray = response.data;
          tipo_documentosArray.map(function (x) {
            me.tipo_documentos_cli.push({
              text: x.descripcion,
              value: x.idtipo_documento,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_afectacionArray = [];
      axios.get("api/Tipo_Afectacion/Select")
        .then(function (response) {
          tipo_afectacionArray = response.data;
          tipo_afectacionArray.map(function (x) {
            me.tipo_afectacion.push({
              text: x.descripcion,
              value: x.idtipo_afectacion,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_nota_credsArray = [];
      axios.get("api/Tipo_Nota_Creds/Select")
        .then(function (response) {
          tipo_nota_credsArray = response.data;
          tipo_nota_credsArray.map(function (x) {
            me.tipo_nota_creds.push({
              text: x.descripcion,
              value: x.idtipo_nota_cred,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_pagosArray = [];
      axios.get("api/Tipo_Pagos/SelectVenta")
        .then(function (response) {
          tipo_pagosArray = response.data;
          tipo_pagosArray.map(function (x) {
            me.tipo_pagos.push({
              text: x.descripcion,
              value: x.idtipo_pago,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion SELECT

    //#region NOTA CREDITO
    enviarNotaCreditoSunatBeta() {
      let me = this;

      me.desabilitar = true;
      me.detalle_pedidos = []; // Limpiamos array para llenarlo
      me.convertirDetalleCPE(); // Actualizamos datos en detalle_pedidos para venta

      axios.post("api/Movimientos/EnviarNotaCreditoBeta", {
        // Enviamos a probar
        idsucursal: parseInt(me.usuario.idsucursal),
        idtipo_servicio: me.idtipo_servicio,
        subtotal_gravado: parseFloat(me.subtotal_gravado),
        gratuito: parseFloat(me.gratuito),
        igv_gravado: parseFloat(me.igv_gravado),
        importe_total: parseFloat(me.importe_total),
        placa: me.placa,
        observacion: me.observacion,
        //NRO_COMPROBANTE: "FF01-" + "1", // FF01-1 Nota de credito
        // Datos comprobante de referencia para nota de credito
        Nro_otr_comprobante: me.doc_ref,
        Cod_otr_comprobante: me.cod_doc_ref,
        Cod_tipo_motivo: me.idtipo_nota_cred,
        Descripcion_motivo: me.removeAccents(me.motivo.toUpperCase()),
        // Datos del Cliente Receptor
        idpersona: me.idpersona, // NRO_DOCUMENTO_CLIENTE, RAZON_SOCIAL_CLIENTE, DIRECCION_CLIENTE
        idtipo_documento: me.idtipo_documento, // 1 = dni, 6 = ruc
        // Detalle de nuestra FE
        detalle_pedidos: me.detalle_pedidos,
      })
        .then(function (response) {
          me.desabilitar = false;
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
        })
        .catch(function (error) {
          me.desabilitar = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    guardarNotaCredito() {
      let me = this;

      me.desabilitar = true; // Desabilitamos boton guardar
      me.detalle_pedidos = []; // Limpiamos array para llenarlo

      if (me.idtipo_nota_cred == "07" && me.afecta_stock == "N") {
        me.desabilitar = false;
        return me.snackBar({ cl: "warning", msg: "El motivo de emisión no esta permitido para las ventas con origen RECIBO." });
      }

      me.convertirDetalleCPE(); // Actualizamos datos en detalle_pedidos para NC

      axios.post("api/Movimientos/CrearNotaCredito", {
        idsucursal: parseInt(me.usuario.idsucursal),
        idtipo_servicio: me.idtipo_servicio, // FE
        idpersona: me.idpersona, //FE
        idusuario: parseInt(me.usuario.idusuario),
        igv: parseFloat(me.igv),
        subtotal_gravado: parseFloat(me.subtotal_gravado),
        gratuito: parseFloat(me.gratuito),
        igv_gravado: parseFloat(me.igv_gravado),
        importe_total: parseFloat(me.importe_total),
        placa: me.placa,
        observacion: me.observacion,
        idreferencia: me.idmovimiento,
        ref_comprobante: me.cod_doc_ref + "-" + me.doc_ref,
        idtipo_nota_cred: me.idtipo_nota_cred,
        motivo: me.removeAccents(me.motivo.toUpperCase()),
        idtipo_pago: me.afecta_stock == "N" ? 6 : 1, // 6 = Contado - Ninguno
        afecta_stock: me.afecta_stock,
        detalle_pedidos: me.detalle_pedidos,
      })
        .then(function (response) {
          me.ocultarComprobanteNC();
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta });
          var printid = response.data.idmovimiento;
          me.listar(printid);
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
          me.listar();
        });
    },

    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    // Eliminar detalle pedido NC y Venta
    eliminarItemDetallePedido(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    verDetallesNotaCredito(item) {
      this.limpiar();
      this.idpedido = item.idpedido;
      this.idtipo_servicio = item.idtipo_servicio;
      this.igv = parseFloat(item.igv);
      this.idmovimiento = item.idmovimiento; // Venta
      this.doc_ref = item.serie_comprobante + "-" + item.num_comprobante;
      this.cod_doc_ref = item.idtipo_comprobante; // boleta = 03 o factura = 01
      this.idpersona = item.idpersona;
      this.afecta_stock = item.afecta_stock;
      this.placa = item.placa;
      this.observacion = item.observacion;
      this.selectCliente(item.idpersona);
      this.listarDetallePedidos(item.idpedido);
      this.verNuevaNotaCredito = 1;
    },

    ocultarComprobanteNC() {
      this.verNuevaNotaCredito = 0;
      this.desabilitar = false; // Habilitamos boton guardar NC
      this.limpiar();
    },
    //#endregion NOTA CREDITO

    //#region IMPRESION
    // Para descargar pdf de blob
    savePdf() {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(this.blobPdf);
      var fileName = this.serie_comprobante + "-" + this.num_comprobante;
      link.download = fileName;
      link.click();
    },

    // Llamamos de main.js printJS
    printExternal() {
      printJS({
        printable: this.stringPdf.replace("data:application/pdf;filename=generated.pdf;base64,", ""),
        type: "pdf",
        base64: true,
      });
    },

    cargaComprobante(id) {
      this.limpiar();

      const selectId = this.ventas.find(
        (elemento) => elemento.idmovimiento === id
      );

      this.idmovimiento = selectId.idmovimiento;
      this.idtipo_pago = selectId.idtipo_pago;
      this.idtipo_servicio = selectId.idtipo_servicio;
      if (this.idtipo_pago == 4) { this.listarDetalleCuentasxC(this.idmovimiento); }
      this.sucursal = selectId.sucursal;
      this.idtipo_comprobante = selectId.idtipo_comprobante;
      this.comprobante = selectId.comprobante;
      this.serie_comprobante = selectId.serie_comprobante;
      this.num_comprobante = selectId.num_comprobante;
      this.subtotal_gravado = selectId.subtotal_gravado;
      this.gratuito = selectId.gratuito;
      this.igv_gravado = selectId.igv_gravado;
      this.importe_total = selectId.importe_total;
      this.importe_letras = selectId.importe_letras;
      this.placa = selectId.placa;
      this.observacion = selectId.observacion;
      this.hash_cpe = selectId.hash_cpe;
      this.ref_comprobante = selectId.ref_comprobante;
      this.motivo = selectId.motivo;
      this.idpedido = selectId.idpedido;
      //this.listarDetallePedidos(selectId.idpedido);
      this.listarDetallePedidos(selectId.idpedido);
      // Cliente
      this.idtipo_documento = selectId.idtipo_documento;
      this.cliente = selectId.cliente;
      this.num_documento = selectId.num_documento;
      this.direccion = selectId.direccion;
      this.nom_ubigeo = selectId.nom_ubigeo;
      this.telefono = selectId.telefono;
      this.email = selectId.email;
      this.fecha = selectId.fecha;
      this.descrip_pago = selectId.descrip_pago;
      this.igv = selectId.igv;
      this.moneda = selectId.moneda;
      this.comprobanteModal = 1;
    },

    mostrarComprobante(item) {
      this.cargaComprobante(item.idmovimiento);
    },

    // Lista detalle de cuenta x cobrar
    listarDetalleCuentasxC(id) {
      let me = this;
      me.detalleCuentasxC = [];
      axios.get("api/Detalle_Cuentas/ListarDetallesCxC/" + id)
        .then(function (response) {
          me.detalleCuentasxC = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    ocultarComprobanteImp() {
      this.comprobanteModal = 0;
      this.disableBMail = true;
      this.detalleCuentasxC = [];
      // Limpiamos div carga de qr
      document.getElementById("container").innerHTML = "";
      this.limpiar();
    },
    //#endregion IMPRESION

    //#region det. VENTA, NOTA DE CREDITO, IMPRESION
    listarDetallePedidos(id) {
      let me = this;
      var detallesArray = [];

      axios.get("api/Pedidos/ListarDetallesPedidos/" + id)
        .then(function (response) {
          detallesArray = response.data; // recorremos el array de detallesArray de ventas para formatear el precio_unit_venta
          detallesArray.map(function (x) {
            me.detalles.push({
              idproducto: x.idproducto,
              idunidad_medida: x.idunidad_medida,
              codigo_producto: x.codigo_producto,
              descripcion_adicional: x.descripcion_adicional,
              stock_actual: x.stock_actual,
              iddetalle_compra: x.iddetalle_compra,
              cantidad: x.cantidad,
              cant_tope: x.cantidad,
              precio_unit_venta: x.precio_unit_venta.toFixed(2),
              descto_item: x.descto_item,
              precio_venta: x.precio_venta,
              idprod_sunat: x.idprod_sunat,
              idtipo_afectacion: x.idtipo_afectacion,
              precio_unit_compra: me.common.roundOut((x.idtipo_servicio == 3 ? x.precio_unit_compra : x.precio_unit_compra * me.tc), 2) // > compra
            });
          });
          if (me.datos.formatimpresion == "1") {
            me.crearPDFTK();
          } else if (me.datos.formatimpresion == "2") {
            me.crearPDFA4();
          } else {
            console.log("No existe un formato definido de impresión.");
          }
          // console.log(me.detalles);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion det. VENTA, NOTA DE CREDITO, IMPRESION

    //#region EMAIL
    enviarEmail() {
      let me = this;
      me.desabilitar = true; // Desabilitamos boton enviar

      axios.put("api/Movimientos/EnviarEmail", {
        idmovimiento: me.idmovimiento,
        cliente: me.cliente,
        email: me.email,
      })
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta });
          me.emailCerrar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    emailMostrar() {
      this.adModalEmailCliente = 1;
      this.adComprobante = this.serie_comprobante + "-" + this.num_comprobante;
    },

    emailCerrar() {
      this.adModalEmailCliente = 0;
      this.desabilitar = false;
    },
    //#endregion EMAIL

    //#region PERSONA
    extraerDocumento() {
      let me = this;
      me.desabilitarBuscar = true;

      if (me.idtipo_documento_pers == 1) {
        axios.get("api/Personas/ConsultarDni", {
          params: {
            nrodoc: me.num_documento,
          },
        })
          .then(function (response) {
            //console.log(response.data)
            me.desabilitarBuscar = false;
            if (response.data.exito == true) {
              me.nombre = response.data.apellidoPaterno + " " + response.data.apellidoMaterno + " " + response.data.nombres;
              me.idubigeo = "000000";
              me.selectUbigeo(me.idubigeo);
              me.direccion = "";
              me.snackBar({ cl: "success", msg: response.data.mensaje });
            } else {
              me.idubigeo = "";
              me.nombre = "";
              me.direccion = "";
              me.snackBar({ cl: "error", msg: response.data.mensaje });
            }
          })
          .catch((err) => {
            me.desabilitarBuscar = false;
            me.idubigeo = "";
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: "Hubo un error" });
          });
      } else if (me.idtipo_documento_pers == 6) {
        axios.post("api/Personas/Padron", {
          ruc: me.num_documento,
        })
          .then(function (response) {
            me.desabilitarBuscar = false;
            me.idubigeo = response.data.ubigeo;
            me.selectUbigeo(me.idubigeo);
            me.nombre = response.data.razon;
            me.direccion =
              response.data.direccion == null
                ? ""
                : response.data.direccion.trim();
            me.snackBar({ cl: "info", msg: "Contribuyente con estado " + response.data.estado + " y condición " + response.data.condicion });
          })
          .catch(function (error) {
            me.desabilitarBuscar = false;
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: error.response.data });
          });
      }
    },

    guardarPersona() {
      let me = this;
      me.desabilitarPer = true;

      axios.post("api/Personas/Crear", {
        tipo_persona: "Cliente",
        nombre: me.nombre,
        idtipo_documento: me.idtipo_documento_pers,
        num_documento: me.num_documento,
        idubigeo: me.idubigeo,
        direccion: me.direccion,
        telefono: me.telefono,
        email: me.email,
      })
        .then((response) => {
          me.idpersona = response.data.idpersona;
          me.selectCliente(me.idpersona);
          me.desabilitarPer = false;
          me.snackBar({ cl: "success", msg: response.data.mensaje });
          me.closePersona();
        })
        .catch(function (error) {
          me.desabilitarPer = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    mostrarPersona() {
      this.verPersona = true;
    },

    closePersona() {
      this.verPersona = false;
      this.idtipo_comprobante = "";
      this.limpiarPersona();
    },
    limpiarPersona() {
      this.idtipo_documento_pers = "";
      this.num_documento = "";
      this.idubigeo = "";
      this.ubigeos = [];
      this.nombre = "";
      this.direccion = "";
      this.email = "";
      this.telefono = "";
    },
    //#endregion PERSONA

    //#region CAPTURA
    iniciarEscaneo() {
      this.codigo_barra = ""
      this.lector = new BrowserMultiFormatReader()
      this.escaneando = true
      this.dialogCamara = true

      this.$nextTick(() => {
        // Espera a que el DOM se actualice (video disponible)
        this.lector.decodeFromConstraints(
          {
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            }
          },
          this.$refs.video,
          (result, err) => {
            if (result && this.escaneando) {
              this.codigo_barra = result.getText()
              this.detenerEscaneo()
              this.buscarCodigoBarra()
            }
          }
        )
        /* this.lector.decodeFromVideoDevice(null, this.$refs.video, (result, err) => {
          if (result && this.escaneando) {
            this.codigo_barra = result.getText()
            this.detenerEscaneo()
            this.buscarCodigoBarra()
          }
        }) */
      })
    },

    detenerEscaneo() {
      if (this.lector) {
        this.lector.reset()
        this.escaneando = false
        this.dialogCamara = false;
      }
    },
    //#endregion CAPTURA

    limpiar() {
      this.igv = parseFloat(this.datos.igv); // requerido
      this.idmovimiento = "";
      this.idtipo_servicio = 5; // Venta Soles
      this.comprobante = "";
      this.serie_comprobante = "";
      this.num_comprobante = "";
      this.importe_letras = "";
      this.adComprobante = "";
      this.placa = "";
      this.observacion = "";
      this.hash_cpe = "";
      this.idtipo_nota_cred = "";
      this.doc_ref = "";
      this.cod_doc_ref = "";
      this.clientes = [];
      this.subtotal_gravado = 0;
      this.gratuito = 0;
      this.igv_gravado = 0;
      this.importe_total = 0;
      this.detalles = [];
      this.detalle_pedidos = [];
      this.idpedido = 0;
      // Cliente
      this.cliente = "";
      this.num_documento = "";
      this.direccion = "";
      this.telefono = "";
      this.email = "";
      this.fecha = "";
      this.moneda = "";
      this.ref_comprobante = "";
      this.motivo = "";
      this.afecta_stock = "";
      this.desabilitar = false;
      this.adicional = false;
      // Venta
      this.codigo_barra = ""; // Buscar codigo de barras
      this.idtipo_comprobante = "";
      this.iddetalle_comprobante_sucursal = "";
      this.idpersona = "";
      this.idtipo_documento = "";
      this.idtipo_pago = "";
      this.total_pago = 0;
      this.num_operacion = "";
      this.fecha_vencimiento = moment().format("YYYY-MM-DD"); // Cronograma de pagos
      this.fechaseleccionada(this.fecha_vencimiento); // Cargamos fecha actual a fecha_vencimiento y fecha_vencimiento_formateada
      this.no_afecta = false;
      this.stringPdf = "";
      this.blobPdf = "";
    },

    crearPDFTK() {
      var doc = new jsPDF("p", "mm", [78, 270]);
      var centro = doc.internal.pageSize.width / 2;
      var imgData = "data:image/png;base64," + this.logo;
      var subir = "";

      var nomcomprob = "";

      if (this.idtipo_comprobante == "00") {
        nomcomprob = this.comprobante.toUpperCase();
        subir = false;
      } else {
        // FE
        nomcomprob = this.comprobante.toUpperCase() + " ELECTRONICA";
        // QR
        var canvasDiv = document.createElement("div"); // Nuevo elemento dom, si solo hay una página, puede usar el elemento de página directamente
        canvasDiv.id = "canvas";
        this.$refs.qrCodeUrl.append(canvasDiv);
        var qrcode = new QRCode("canvas", {
          // qrcode genera un código QR
          text: this.datos.ruc + "|" + this.idtipo_comprobante + "|" + this.serie_comprobante + "|" + this.num_comprobante + "|" + this.igv_gravado + "|" + this.importe_total + "|" + moment(this.fecha).format("DD/MM/YYYY") + "|" + this.idtipo_documento + "|" + this.num_documento + "|" + this.hash_cpe,
          width: 120,
          height: 120,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        let canvas = document.getElementById("canvas").querySelector("canvas"); // Obtener el elemento canvas
        var imageQR = canvas.toDataURL();
        canvas = null;
        subir = true;
        // Fin QR
      }

      var columns = [
        { header: "DESCRIPCIÓN", dataKey: "descripcion_adicional" },
        { header: "CANT.", dataKey: "cantidad" },
        { header: "P/U", dataKey: "precio_unit_venta" },
        { header: "TOTAL", dataKey: "subtotal" },
      ];
      var body = [];
      var foot = [];

      for (var i = 0; i < this.detalles.length; i++) {
        body.push({
          cantidad: this.detalles[i].cantidad.toFixed(2),
          descripcion_adicional: (this.detalles[i].descripcion_adicional).substring(0, 30),
          precio_unit_venta: numeral(this.detalles[i].precio_unit_venta).format("###,##0.00"),
          subtotal: numeral(this.detalles[i].precio_venta).format("###,##0.00"),
        });

        if (i === this.detalles.length - 1) {
          if (this.idtipo_comprobante == "00") {
            foot.push([
              {
                content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                colSpan: 3,
                styles: { fontStyle: "bold" },
              },
              {
                content: numeral(this.importe_total).format("###,##0.00"),
                styles: { fontStyle: "bold" },
              },
            ]);
          } else {
            foot.push(
              [
                {
                  content: "GRAVADA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 3,
                },
                numeral(this.subtotal_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "GRATUITA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 3,
                },
                numeral(this.gratuito).format("###,##0.00"),
              ],
              [
                {
                  content: "IGV " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 3,
                },
                numeral(this.igv_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 3,
                  styles: { fontStyle: "bold" },
                },
                {
                  content: numeral(this.importe_total).format("###,##0.00"),
                  styles: { fontStyle: "bold" },
                },
              ]
            );
          }
        }
      }
      // Logo
      var ancho = 33;
      var alto = 23;
      doc.addImage(imgData, "JPEG", centro - ancho / 2, 4, ancho, alto);

      // Datos empresa
      let bodye = [];
      // Validar si se debe mostrar la fecha de vencimiento
      if (this.datos.ruc != "12345678901") {
        bodye.push({ columna0: this.datos.ruc });
      };
      bodye.push(
        { columna0: this.datos.dirsucursal, },
        { columna0: this.datos.dptosucursal + " - " + this.datos.provsucursal + " - " + this.datos.dttosucursal, },
        { columna0: this.datos.mailsucursal },
        { columna0: this.datos.telsucursal },
        { columna0: nomcomprob },
        { columna0: this.serie_comprobante + "-" + this.num_comprobante },
      );

      doc.autoTable({
        theme: "plain",
        margin: { left: 5, right: 5, top: 30 },
        headStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "bold",
          fontSize: 8,
          halign: "center",
        },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 8,
          textColor: 0,
          halign: "center",
        },

        body: bodye,
        columns: [{ header: this.datos.emp_comercial, dataKey: "columna0" }],
        // En negrita las filas
        /* didParseCell: function (data) {
           if (data.row.index === 0) {
             data.cell.styles.fontStyle = "bold";
           }
           if (data.row.index === 5) {
                       data.cell.styles.fontStyle = "bold";
                     }
                     if (data.row.index === 6) {
                       data.cell.styles.fontStyle = "bold";
                     } 
         },*/
      });

      // DESTINATARIO
      let bodyd = [
        { columna0: "FECHA EMISIÓN: " + moment(this.fecha).format("DD/MM/YYYY") }
      ];
      // Validar si se debe mostrar la fecha de vencimiento
      if (this.idtipo_pago == 4 && this.detalleCuentasxC.length > 0 && this.detalleCuentasxC[0].fecha_vencimiento) {
        bodyd.push({
          columna0: "FECHA DE VENC.: " + moment(this.detalleCuentasxC[0].fecha_vencimiento).format("DD/MM/YYYY")
        });
      };
      bodyd.push(
        { columna0: "CLIENTE: " + this.cliente },
        { columna0: (this.num_documento.length == 11 ? "RUC: " : "DNI: ") + this.num_documento },
        { columna0: "DIRECCIÓN: " + this.direccion + " - " + this.nom_ubigeo }
      );
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 2,
        theme: "plain",
        //tableLineColor: 0,
        //tableLineWidth: 0.2,
        margin: { left: 5, right: 5 },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 8,
          textColor: 0,
        },
        body: bodyd
      });

      // DETALLE DE VENTA
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 1,
        theme: "plain",
        columns,
        body,
        foot,
        margin: { left: 5, right: 5 },
        //styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          cellPadding: 0.3,
          fontSize: 8,
          halign: "center",
        },
        bodyStyles: { cellPadding: 0.5, textColor: 0, fontSize: 8 },
        footStyles: {
          cellPadding: 0.3,
          fontStyle: "normal",
          fillColor: [255, 255, 255],
          textColor: 0,
          fontSize: 8,
          halign: "right",
        },
        columnStyles: {
          descripcion_adicional: { cellWidth: "auto" },
          cantidad: { cellWidth: 10, halign: "center" },
          precio_unit_venta: { cellWidth: 12, halign: "right" },
          subtotal: { cellWidth: 14, halign: "right" },
        },
      });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 1,
        theme: "plain",
        margin: { left: 5, right: 5 },
        bodyStyles: {
          cellPadding: 0.3,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 8,
          textColor: 0,
        },
        body: [
          //{ columna0: "CAJERO: " + this.usuario.idusuario, },
          { columna0: "SON: " + this.importe_letras + (this.moneda == "S" ? " SOLES" : " DOLARES AMERICANOS") },
          { columna0: "FORMA DE PAGO: " + this.descrip_pago },
        ],
      });

      let finalY = doc.lastAutoTable.finalY;
      // doc.text("SON: " + this.importe_letras + (this.moneda == "S" ? " SOLES" : " DOLARES AMERICANOS"), 5, finalY = finalY + 3);
      // doc.text("FORMA DE PAGO: " + this.descrip_pago, 5, finalY = finalY + 3);

      // Nota credito
      if (this.idtipo_comprobante == "07") {
        doc.text("MOTIVO: " + this.motivo, 5, finalY = finalY + 3);
        doc.text("DOC. AFECTADO: " + this.ref_comprobante.substring(3, 16), 5, finalY = finalY + 3);
      }

      // Referencia de comprobante convertido
      if (this.idtipo_comprobante == "00" && this.ref_comprobante != "") {
        doc.text("REFERENCIA: " + this.ref_comprobante.substring(3, 16), 5, finalY = finalY + 3);
      }

      if (this.placa != "") {
        doc.text("PLACA: " + this.placa, 5, finalY = finalY + 3);
      }

      if (this.observacion != "") {
        doc.text("OBSERVACIONES: " + this.observacion, 5, finalY = finalY + 3);
      }

      if (imageQR) {
        doc.text("Representación impresa de la " + this.comprobante + " Electronica", centro, finalY = finalY + 4, "center");
        //doc.text("consulte su comprobante en SUNAT", centro, finalY = finalY + 3, "center");
        doc.addImage(imageQR, "JPEG", 26.5, finalY = finalY + 2, 25, 25);
        //doc.text("GRACIAS POR SU COMPRA", centro, finalY + 47, "center");
        doc.text("RESUMEN", centro, finalY = finalY + 28, "center");
        doc.setFontSize(6);
        doc.text(this.hash_cpe, centro, finalY = finalY + 3, "center");

        doc.setFont("helvetica", "bold");
        doc.text("Desarrollado por UrpiFact", centro, finalY = finalY + 3, "center");
      }

      this.stringPdf = doc.output("datauristring");
      this.blobPdf = doc.output("blob");
      subir ? this.subirPdf() : null; // Subimos pdf blob a nuetra api
      /* Crear PDF venta */
    },

    subirPdf() {
      let me = this;
      // Código para editar usuario
      let formData = new FormData();
      formData.append("file", me.blobPdf);
      formData.append("nomcomprobante", me.datos.ruc + "-" + me.idtipo_comprobante + "-" + me.serie_comprobante + "-" + me.num_comprobante);
      axios.post("api/Movimientos/SubirFile", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          me.disableBMail = false; // se habilita boton para enviar por mail
          //console.log(response);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    crearPDFA4() {
      if (this.datos.ruc == '10296753136' || this.datos.ruc == '20611372761') { // Madeleyne y Corporacion Multiservicios
        this.impRym();
      } else {
        this.impOtros();
      }
    },

    // Madeleyne
    impRym() {
      var doc = new jsPDF("p", "mm", [210, 297]);
      var centro = doc.internal.pageSize.width / 2;
      var imgData = "data:image/png;base64," + this.logo;
      var imgDataMarca = "data:image/png;base64,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";
      var subir = "";
      var nomcomprob = "";

      if (this.idtipo_comprobante == "00") {
        nomcomprob = this.comprobante.toUpperCase();
        subir = false;
      } else {
        // FE
        nomcomprob = this.comprobante.toUpperCase() + " ELECTRONICA";
        // QR
        var canvasDiv = document.createElement("div"); // Nuevo elemento dom, si solo hay una página, puede usar el elemento de página directamente
        canvasDiv.id = "canvas";
        this.$refs.qrCodeUrl.append(canvasDiv);
        var qrcode = new QRCode("canvas", {
          // qrcode genera un código QR
          text: this.datos.ruc + "|" + this.idtipo_comprobante + "|" + this.serie_comprobante + "|" + this.num_comprobante + "|" + this.igv_gravado + "|" + this.importe_total + "|" + moment(this.fecha).format("DD/MM/YYYY") + "|" + this.idtipo_documento + "|" + this.num_documento + "|" + this.hash_cpe,
          width: 120,
          height: 120,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        let canvas = document.getElementById("canvas").querySelector("canvas"); // Obtener el elemento canvas
        var imageQR = canvas.toDataURL();
        canvas = null;
        subir = true;
        // Fin QR
      }

      var columns = [
        { header: "CANT.", dataKey: "cantidad" },
        { header: "U/M", dataKey: "idunidad_medida" },
        { header: "DESCRIPCIÓN", dataKey: "descripcion_adicional" },
        { header: "P/U", dataKey: "precio_unit_venta" },
        { header: "TOTAL", dataKey: "subtotal" },
      ];
      var body = [];
      var foot = [];

      for (var i = 0; i < this.detalles.length; i++) {
        body.push({
          cantidad: this.detalles[i].cantidad.toFixed(2),
          idunidad_medida: this.detalles[i].idunidad_medida,
          descripcion_adicional: this.detalles[i].descripcion_adicional,
          precio_unit_venta: numeral(this.detalles[i].precio_unit_venta).format("###,##0.00"),
          subtotal: numeral(this.detalles[i].precio_venta).format("###,##0.00"),
        });

        if (i === this.detalles.length - 1) {
          if (this.idtipo_comprobante == "00") {
            foot.push([
              {
                content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                colSpan: 4,
                styles: { fontStyle: "bold" },
              },
              {
                content: numeral(this.importe_total).format("###,##0.00"),
                styles: { fontStyle: "bold" },
              },
            ]);
          } else {
            foot.push(
              [
                {
                  content: "GRAVADA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.subtotal_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "GRATUITA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.gratuito).format("###,##0.00"),
              ],
              [
                {
                  content: "IGV " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.igv_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                  styles: { fontStyle: "bold" },
                },
                {
                  content: numeral(this.importe_total).format("###,##0.00"),
                  styles: { fontStyle: "bold" },
                },
              ]
            );
          }
        }
      }
      // Logo
      var ancho = 46;
      var alto = 32.27;
      doc.addImage(imgData, "JPEG", 10, 8, ancho, alto);

      // Marca
      var anchom = 161.925;
      var altom = 18.26;

      // Datos empresa
      doc.autoTable({
        theme: "plain",
        margin: { left: 50, right: 70, top: 23 },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "bold",
          fontSize: 8,
          textColor: 0,
          halign: "center",
        },
        body: [
          //[{ content: this.datos.emp_comercial, styles: { fontSize: 25 } }],
          [{ content: this.datos.empresa, styles: { fontSize: 9, textColor: this.common.hexToRgb(this.datos.color) } }],
          [{ content: this.datos.eslogan, styles: { fontSize: 7.3, fontStyle: "normal" } }],
          //[{ content: "Email: " + this.datos.mailsucursal + " Tel: " + this.datos.telsucursal }],
          [{ content: "Tel: " + this.datos.telsucursal, styles: { fontStyle: "normal" } }],
          [{ content: this.datos.dirsucursal + " " + this.datos.dptosucursal + " - " + this.datos.provsucursal + " - " + this.datos.dttosucursal, styles: { fontStyle: "normal" } }]
        ],
      });

      // Nombre comercial
      doc.setFont("courier", "bold");
      doc.setFontSize(40);
      doc.text(this.datos.emp_comercial, 50, 17);
      // COMPROBANTE DE PAGO
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      //doc.roundedRect(141, 17, 54, 18, 1, 1);
      doc.setLineWidth(0.2);
      doc.setDrawColor(82, 86, 89);
      doc.rect(141, 23.5, 54, 16.5);
      doc.text("RUC " + this.datos.ruc, 168, 28, "center");
      doc.setFontSize(8);
      doc.text(nomcomprob, 168, 33, "center");
      doc.setFontSize(9);
      doc.text(this.serie_comprobante + "-" + this.num_comprobante, 168, 38, "center");

      // DESTINATARIO
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 3,
        theme: "plain",
        //tableLineColor: [82, 86, 89],
        //tableLineWidth: 0.2,
        margin: { left: 15, right: 15 },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "bold",
          fontSize: 7.5,
          textColor: 0,
        },
        columnStyles: {
          columna0: { cellWidth: 133 },
          columna1: { cellWidth: 47 },
        },
        body: [
          //{ columna0: "CAJERO: " + this.usuario.idusuario, },
          { columna0: (this.num_documento.length == 11 ? "RUC: " : "DNI: ") + this.num_documento, columna1: "FECHA EMISIÓN: " + moment(this.fecha).format("DD/MM/YYYY") },
          { columna0: "SEÑOR(ES): " + this.cliente, columna1: "FECHA DE VENC: " + (this.idtipo_pago == 4 ? moment(this.detalleCuentasxC[0].fecha_vencimiento).format("DD/MM/YYYY") : moment(this.fecha).format("DD/MM/YYYY")) },
          { columna0: "DIRECCIÓN: " + this.direccion + " - " + this.nom_ubigeo, columna1: this.moneda == "S" ? "MONEDA: SOLES" : "MONEDA: DOLARES AMERICANOS" },
        ],
      });

      doc.addImage(imgDataMarca, "JPEG", 24.0375, doc.lastAutoTable.finalY + 2, anchom, altom);

      // DETALLE DE VENTA
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 24,
        theme: "grid",
        columns,
        body,
        foot,
        margin: { left: 15, right: 15 },
        //styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal" | "bold",
          fontSize: 7.5,
          halign: "center",
          fillColor: [82, 86, 89],
          textColor: 255,
          lineColor: [82, 86, 89],
          lineWidth: 0.2,
        },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 7.5,
          textColor: 0,
          lineColor: [82, 86, 89],
          lineWidth: 0.2,
        },
        footStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fillColor: 255,
          textColor: 0,
          fontSize: 7.5,
          halign: "right",
        },
        columnStyles: {
          cantidad: { cellWidth: 15, halign: "center" },
          idunidad_medida: { cellWidth: 15, halign: "center" },
          descripcion_adicional: { cellWidth: "auto" },
          precio_unit_venta: { cellWidth: 20, halign: "right" },
          subtotal: { cellWidth: 20, halign: "right" },
        },
      });

      let finalY = doc.lastAutoTable.finalY;
      doc.setFontSize(7.5);

      if (this.datos.ctasbanco.trim().length > 0) {
        doc.text(this.datos.ctasbanco, 15, finalY = finalY - 1);
      }

      doc.text("SON: " + this.importe_letras + (this.moneda == "S" ? " SOLES" : " DOLARES AMERICANOS"), 15, finalY = finalY + 4);

      doc.text("FORMA DE PAGO: " + this.descrip_pago, 15, finalY = finalY + 4);

      // Nota credito
      if (this.idtipo_comprobante == "07") {
        doc.text("MOTIVO: " + this.motivo, 15, finalY = finalY + 4);
        doc.text("DOC. AFECTADO: " + this.ref_comprobante.substring(3, 16), 15, finalY = finalY + 4);
      }

      // Referencia de comprobante convertido Recibo interno
      if (this.idtipo_comprobante == "00" && this.ref_comprobante != "") {
        doc.text("REFERENCIA: " + this.ref_comprobante.substring(3, 16), 15, finalY = finalY + 4);
      }

      if (this.placa != "") {
        doc.text("PLACA: " + this.placa, 15, finalY = finalY + 4);
      }

      if (this.observacion != "") {
        doc.text("OBSERVACIONES: " + this.observacion, 15, finalY = finalY + 4);
      }

      // Si existe QR mostramos mensaje de CPE
      if (imageQR) {
        doc.setFontSize(7.5);
        doc.setFont("helvetica", "normal");
        doc.addImage(imageQR, "JPEG", 162, finalY = finalY + 3, 28, 28);

        doc.text("Resumen: " + this.hash_cpe, 20, finalY = finalY + 4);
        doc.text("Representación impresa de la " + this.comprobante + " Electronica", 20, finalY = finalY + 4);
        doc.text("Consulte su comprobante en SUNAT", 20, finalY = finalY + 4);
        doc.setFontSize(7);
        doc.setFont("helvetica", "bold");
        doc.text("Desarrollado por UrpiFact", 20, finalY = finalY + 4);
      }

      this.stringPdf = doc.output("datauristring");
      this.blobPdf = doc.output("blob");
      subir ? this.subirPdf() : null; // Subimos pdf blob a nuetra api
    },

    impOtros() {
      var doc = new jsPDF("p", "mm", [210, 297]);
      var centro = doc.internal.pageSize.width / 2;
      var imgData = "data:image/png;base64," + this.logo;
      var subir = "";
      var nomcomprob = "";

      if (this.idtipo_comprobante == "00") {
        nomcomprob = this.comprobante.toUpperCase();
        subir = false;
      } else {
        // FE
        nomcomprob = this.comprobante.toUpperCase() + " ELECTRONICA";
        // QR
        var canvasDiv = document.createElement("div"); // Nuevo elemento dom, si solo hay una página, puede usar el elemento de página directamente
        canvasDiv.id = "canvas";
        this.$refs.qrCodeUrl.append(canvasDiv);
        var qrcode = new QRCode("canvas", {
          // qrcode genera un código QR
          text: this.datos.ruc + "|" + this.idtipo_comprobante + "|" + this.serie_comprobante + "|" + this.num_comprobante + "|" + this.igv_gravado + "|" + this.importe_total + "|" + moment(this.fecha).format("DD/MM/YYYY") + "|" + this.idtipo_documento + "|" + this.num_documento + "|" + this.hash_cpe,
          width: 120,
          height: 120,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        let canvas = document.getElementById("canvas").querySelector("canvas"); // Obtener el elemento canvas
        var imageQR = canvas.toDataURL();
        canvas = null;
        subir = true;
        // Fin QR
      }

      var columns = [
        { header: "CANT.", dataKey: "cantidad" },
        { header: "U/M", dataKey: "idunidad_medida" },
        { header: "DESCRIPCIÓN", dataKey: "descripcion_adicional" },
        { header: "P/U", dataKey: "precio_unit_venta" },
        { header: "TOTAL", dataKey: "subtotal" },
      ];
      var body = [];
      var foot = [];

      for (var i = 0; i < this.detalles.length; i++) {
        body.push({
          cantidad: this.detalles[i].cantidad.toFixed(2),
          idunidad_medida: this.detalles[i].idunidad_medida,
          descripcion_adicional: this.detalles[i].descripcion_adicional,
          precio_unit_venta: numeral(this.detalles[i].precio_unit_venta).format("###,##0.00"),
          subtotal: numeral(this.detalles[i].precio_venta).format("###,##0.00"),
        });

        if (i === this.detalles.length - 1) {
          if (this.idtipo_comprobante == "00") {
            foot.push([
              {
                content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                colSpan: 4,
                styles: { fontStyle: "bold" },
              },
              {
                content: numeral(this.importe_total).format("###,##0.00"),
                styles: { fontStyle: "bold" },
              },
            ]);
          } else {
            foot.push(
              [
                {
                  content: "GRAVADA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.subtotal_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "GRATUITA " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.gratuito).format("###,##0.00"),
              ],
              [
                {
                  content: "IGV " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.igv_gravado).format("###,##0.00"),
              ],
              [
                {
                  content: "IMPORTE TOTAL " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                  styles: { fontStyle: "bold" },
                },
                {
                  content: numeral(this.importe_total).format("###,##0.00"),
                  styles: { fontStyle: "bold" },
                },
              ]
            );
          }
        }
      }
      // Logo
      var ancho = 35;
      var alto = 24.7;
      doc.addImage(imgData, "JPEG", 15, 19, ancho, alto);

      // Datos empresa
      doc.autoTable({
        theme: "plain",
        margin: { left: 50, right: 70, top: 17 },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "bold",
          //fontSize: 8,
          textColor: 0,
          halign: "center",
        },
        body: [
          [{ content: this.datos.emp_comercial, styles: { fontSize: 15, } }],
          [{ content: this.datos.empresa, styles: { fontSize: 9 } }],
          [{ content: this.datos.eslogan, styles: { fontSize: 7.3, fontStyle: "normal" } }],
          [{ content: "Email: " + this.datos.mailsucursal + " Tel: " + this.datos.telsucursal, styles: { fontSize: 7.3, fontStyle: "normal" } }],
          [{ content: this.datos.dirsucursal + " " + this.datos.dptosucursal + " - " + this.datos.provsucursal + " - " + this.datos.dttosucursal, styles: { fontSize: 7.3, fontStyle: "normal" } }]
        ],
      });

      // COMPROBANTE DE PAGO
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      //doc.roundedRect(141, 17, 54, 18, 1, 1);
      doc.setLineWidth(0.2);
      doc.setDrawColor(82, 86, 89);
      doc.rect(141, 17, 54, 18);
      doc.text("RUC " + this.datos.ruc, 168, 22, "center");
      doc.setFontSize(8);
      doc.text(nomcomprob, 168, 27, "center");
      doc.setFontSize(9);
      doc.text(this.serie_comprobante + "-" + this.num_comprobante, 168, 32, "center");

      // DESTINATARIO

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 5,
        theme: "plain",
        tableLineColor: [82, 86, 89],
        tableLineWidth: 0.2,
        margin: { left: 15, right: 15 },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "bold",
          fontSize: 7.5,
          textColor: 0,
        },
        columnStyles: {
          columna0: { cellWidth: 133 },
          columna1: { cellWidth: 47 },
        },
        body: [
          //{ columna0: "CAJERO: " + this.usuario.idusuario, },
          { columna0: (this.num_documento.length == 11 ? "RUC: " : "DNI: ") + this.num_documento, columna1: "FECHA EMISIÓN: " + moment(this.fecha).format("DD/MM/YYYY") },
          { columna0: "SEÑOR(ES): " + this.cliente, columna1: "FECHA DE VENC: " + (this.idtipo_pago == 4 ? moment(this.detalleCuentasxC[0].fecha_vencimiento).format("DD/MM/YYYY") : moment(this.fecha).format("DD/MM/YYYY")) },
          { columna0: "DIRECCIÓN: " + this.direccion + " - " + this.nom_ubigeo, columna1: this.moneda == "S" ? "MONEDA: SOLES" : "MONEDA: DOLARES AMERICANOS" },
        ],
      });

      // DETALLE DE VENTA
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 2,
        theme: "grid",
        columns,
        body,
        foot,
        margin: { left: 15, right: 15 },
        //styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal" | "bold",
          fontSize: 7.5,
          halign: "center",
          fillColor: [82, 86, 89],
          textColor: 255,
          lineColor: [82, 86, 89],
          lineWidth: 0.2,
        },
        bodyStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 7.5,
          textColor: 0,
          lineColor: [82, 86, 89],
          lineWidth: 0.2,
        },
        footStyles: {
          cellPadding: 0.5,
          font: "helvetica",
          fontStyle: "normal",
          fillColor: 255,
          textColor: 0,
          fontSize: 7.5,
          halign: "right",
        },
        columnStyles: {
          cantidad: { cellWidth: 15, halign: "center" },
          idunidad_medida: { cellWidth: 15, halign: "center" },
          descripcion_adicional: { cellWidth: "auto" },
          precio_unit_venta: { cellWidth: 20, halign: "right" },
          subtotal: { cellWidth: 20, halign: "right" },
        },
      });

      let finalY = doc.lastAutoTable.finalY;
      doc.setFontSize(7.5);

      if (this.datos.ctasbanco.trim().length > 0) {
        doc.text(this.datos.ctasbanco, 15, finalY = finalY - 1);
      }

      doc.text("SON: " + this.importe_letras + (this.moneda == "S" ? " SOLES" : " DOLARES AMERICANOS"), 15, finalY = finalY + 4);

      doc.text("FORMA DE PAGO: " + this.descrip_pago, 15, finalY = finalY + 4);

      // Nota credito
      if (this.idtipo_comprobante == "07") {
        doc.text("MOTIVO: " + this.motivo, 15, finalY = finalY + 4);
        doc.text("DOC. AFECTADO: " + this.ref_comprobante.substring(3, 16), 15, finalY = finalY + 4);
      }

      // Referencia de comprobante convertido Recibo interno
      if (this.idtipo_comprobante == "00" && this.ref_comprobante != "") {
        doc.text("REFERENCIA: " + this.ref_comprobante.substring(3, 16), 15, finalY = finalY + 4);
      }

      if (this.placa != "") {
        doc.text("PLACA: " + this.placa, 15, finalY = finalY + 4);
      }

      if (this.observacion != "") {
        doc.text("OBSERVACIONES: " + this.observacion, 15, finalY = finalY + 4);
      }

      // Si existe QR mostramos mensaje de CPE
      if (imageQR) {
        doc.setFontSize(7.5);
        doc.setFont("helvetica", "normal");
        doc.addImage(imageQR, "JPEG", 162, finalY = finalY + 3, 28, 28);

        doc.text("Resumen: " + this.hash_cpe, 20, finalY = finalY + 4);
        doc.text("Representación impresa de la " + this.comprobante + " Electronica", 20, finalY = finalY + 4);
        doc.text("Consulte su comprobante en SUNAT", 20, finalY = finalY + 4);
        doc.setFontSize(7);
        doc.setFont("helvetica", "bold");
        doc.text("Desarrollado por UrpiFact", 20, finalY = finalY + 4);
      }

      this.stringPdf = doc.output("datauristring");
      this.blobPdf = doc.output("blob");
      subir ? this.subirPdf() : null; // Subimos pdf blob a nuetra api
      // Crear PDF venta 
    },
  },
};
</script>

<style scoped>
.right-input>>>input {
  text-align: right;
}

.center-input>>>input {
  text-align: center;
}
</style>